<template>
  <div id="insightsReport">
    <div class="margin-subpages">
      <div class="flex">
        <img :src="$utils('icons', 'groups_black_32dp_30')" class="mr-18" alt="icons_groups_black_32dp_30" />
        <div v-if="this.user.user_type == 'leadership'" class="mock-switch mr-24 flex-mid">
          {{ $t("insights.TEAMS") }}
        </div>
        <div class="switch mr-24" v-else>
          <div class="can-toggle">
            <input class="input" type="checkbox" id="happilyVillageAccess_checked" v-model="typeChecked" />
            <label for="happilyVillageAccess_checked" :class="`${typeChecked ? 'power-off' : 'power-on'}`">
              <div class="switch-body flex-mid">
                <div class="label-select left ml-auto mr-24 mt-2">
                  {{ $t("insights.TEAMS") }}
                </div>
                <div class="label-select right mr-auto ml-20 mt-2">
                  {{ $t("insights.COHORTS") }}
                </div>
              </div>
            </label>
          </div>
        </div>
        <el-select v-model="selectTeam" filterable placeholder="Select" class="input-style"
          :class="[blurMode ? 'blurelement' : '']" @change="handleTeams">
          <el-option v-if="user.user_type !== 'leadership' || showGroup !== 'teams'" class="text-dropdown" key="all"
            :label="`All ${showGroup == 'teams'
                ? `Teams (${optionsTeam.length}`
                : `Cohorts (${optionsCohort.length}`
              })`" value="all"></el-option>
          <el-option class="text-dropdown" :class="[blurMode ? 'blurelement' : '']"
            v-for="item in showGroup == 'teams' ? optionsTeam : optionsCohort" :key="item.key" :label="item.name"
            :value="item.key"></el-option>
        </el-select>
      </div>
      <div class="flex-center mt-16">
        <div class="flex-1">
          <span v-if="typeChecked" class="txtHeader">{{
            $t("insights.REPORT_CARD_BY_TEAM")
            }}</span>
          <span v-else class="txtHeader">{{
            $t("insights.REPORT_CARD_BY_COHORTS")
            }}</span>
        </div>
        <div class="mr-12">
          <span class="fc-4A4A4A fs-16">{{ $t("insights.Sort_by") }}</span>
        </div>
        <div class="showOption">
          <el-menu class="el-menu-demo menuOptionStyle" mode="horizontal" style="width: 220px">
            <el-submenu index="0" style="width: 220px">
              <template slot="title">
                <span class="txtOption2" id="sortby_reportcard">{{
                  $t("insights.Highest_Scores")
                  }}</span>
              </template>
              <el-menu-item index="1" @click="sortBy('highest')" style="font-size: 16px; width: 220px">{{
                $t("insights.Highest_Scores") }}</el-menu-item>
              <el-menu-item index="2" @click="sortBy('lowest')" style="font-size: 16px; width: 220px">{{
                $t("insights.Lowest_Score")
                }}</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="flex-center" style="width: 528px">
        <div class="flex-1">
          <span class="fs-15 op-08">{{ $t("insights.Scores_are_updated_on") }}</span>
        </div>
      </div>
      <div class="divTable">
        <transition name="report-loader-fade" mode="out-in">
          <el-table v-if="loadingDatatable" key="report-table" id="reportTable" :data="datatable.slice(1)" style="width: 100%" :max-height="MaxHeight"
            @header-click="headerClick" :header-cell-style="tableHeaderStyle" :cell-style="cellStyle"
            :row-style="rowStyle" empty-text=" " @row-click="showRowData">
          <el-table-column v-if="datatable.length > 0 && datatable[0] && index == 0" fixed width="350" v-for="(column, index) in datatable[0]" :key="index"
            :render-header="renderOptionQuarter">
            <template slot-scope="scope">
              <div class="">
                <div class="flex-mid mouseover-title">
                  <div style="width: 264px; line-height: 16px">
                    <span v-if="scope.$index == 0" class="fw-700" style="
                        font-size: 15px;
                        color: #747474;
                        word-break: normal;
                      ">{{ scope.row[0] }}</span>
                    <span v-else-if="scope.row[1] == -999" class="fw-400" style="
                        font-size: 13px;
                        color: #b5b5b5;
                        word-break: normal;
                      ">{{ questionMaster[scope.row[0]] }}</span>
                    <!-- <span
                      v-else-if="scope.row[1] == -999 && scope.row[0] !== 'DEBI'"
                      class="fw-400"
                      style="
                        font-size: 13px;
                        color: #b5b5b5;
                        word-break: normal;
                      "
                      >{{ questionMaster[scope.row[0]] }}</span
                    > -->
                    <span v-else-if="questionType[scope.row[0]] == 'NPS'" class="fw-400"
                      style="font-size: 13px; color: #000; word-break: normal">
                      <span class="span-tag mr-4" :class="`span-${tagColor(scope.row[1])}`">{{ $t("insights.NPS") }}</span>
                      <span :class="{'strategic-alignment-link': showGroup === 'teams'}">{{ questionMaster[scope.row[0]] }}</span>
                    </span>
                    <span v-else-if="questionType[scope.row[0]] == 'eNPS'" class="fw-400"
                      style="font-size: 13px; color: #000; word-break: normal">
                      <span class="span-tag mr-4" :class="`span-${tagColor(scope.row[1])}`">{{ $t("insights.eNPS")
                        }}</span>
                      <span :class="{'strategic-alignment-link': showGroup === 'teams'}">{{ questionMaster[scope.row[0]] }}</span>
                    </span>
                    <span v-else-if="questionType[scope.row[0]] == 'DEBI'" class="fw-400"
                      style="font-size: 13px; color: #000; word-break: normal">
                      <span class="span-tag" :class="`span-${tagColorDEBI(scope.row[1])}`">{{ $t("insights.DEBI")
                        }}</span>
                      {{ $t("insights.DEBI_report_card_label") }}
                    </span>
                    <span v-else-if="questionType[scope.row[0]] == 'Index'" class="fw-400"
                      style="font-size: 13px; color: #000; word-break: normal">
                      <span class="span-tag mr-4" :class="`span-${tagColorStrategicAlignment(scope.row[1])}`">{{
                          $t("insights.Alignment") }}</span>
                      <span :class="{'strategic-alignment-link': showGroup === 'teams'}" @click.stop="showGroup === 'teams' ? openStrategicAlignmentModal() : null">
                        {{ questionMaster["Index"] }}
                      </span>
                      <span v-if="shouldShowAlignmentFlag(scope.row[0])" class="alignment-flag ml-2">
                      </span>
                    </span>
                    <span v-else-if="questionType[scope.row[0]] == 'Variance'" class="fw-400"
                      style="font-size: 13px; color: #000; word-break: normal; display: none;">
                      <span class="span-tag" :class="`span-${tagColorStrategicAlignment(scope.row[1])}`">{{
                        $t("insights.Variance") }}</span>
                      {{ questionMaster["Variance"] }}
                    </span>
                    <span v-else-if="questionType[scope.row[0]] == 'WHO-5'" class="fw-400"
                      style="font-size: 13px; color: #000; word-break: normal">
                      <span class="span-tag mr-4" :class="`span-${tagColorIndex(scope.row[1])}`">{{ $t("insights.WHO_5") }}</span>
                      <span :class="{'strategic-alignment-link': showGroup === 'teams'}" @click.stop="showGroup === 'teams' ? openWHO5Modal() : null">
                        {{ questionMaster[scope.row[0]] }}
                      </span>
                    </span>
                    <span v-else-if="questionType[scope.row[0]] == 'eRes'" class="fw-400"
                      style="font-size: 13px; color: #000; word-break: normal">
                      <span class="span-tag" :class="`span-${tagColorIndex(scope.row[1])}`">{{ $t("insights.eRes")
                        }}</span>
                      {{ questionMaster["eRes"] }}
                    </span>
                    <span v-else-if="questionType[scope.row[0]] == 'Culture'" class="fw-400"
                      style="font-size: 13px; color: #000; word-break: normal">
                      <span class="span-tag" :class="`span-${tagColorIndex(scope.row[1])}`">{{ $t("insights.Culture")
                        }}</span>
                      <span :class="{'strategic-alignment-link': showGroup === 'teams'}"
                        @click.stop="showGroup === 'teams' ? openCultureModal() : null">
                        {{ questionMaster["Culture"] }}
                      </span>
                    </span>
                    <span v-else-if="questionMaster[scope.row[0]]" class="fw-400" style="
                        font-size: 13px;
                        color: #000000;
                        word-break: normal;
                      ">{{ questionMaster[scope.row[0]] }}</span>
                    <span v-else-if="categoryMaster[scope.row[0]]" class="fw-900" style="
                        font-size: 13px;
                        color: #000000;
                        word-break: normal;
                      ">{{ (categoryMaster[scope.row[0]]) ? categoryMaster[scope.row[0]].category : '' }}</span>
                    <span v-else-if="scope.row[0] == 'nps'" class="fw-900" style="
                        font-size: 13px;
                        color: #000000;
                        word-break: normal;
                      ">{{ $t("insights.Net_Promoter_Score_c_NPS") }}</span>
                    <span v-else-if="scope.row[0] == 'set1'" class="fw-900" style="
                        font-size: 13px;
                        color: #000000;
                        word-break: normal;
                      ">{{ $t("insights.Culture_Resilience_Well") }}</span>
                    <span v-else-if="scope.row[0] == 'engagement'" class="fw-900" style="
                        font-size: 13px;
                        color: #000000;
                        word-break: normal;
                      ">{{ $t("insights.Engagement_Score") }}</span>
                    <span v-else-if="scope.row[0] == 'strategic_alignment'" class="fw-900"
                      style="
                        font-size: 13px;
                        color: #000000;
                        word-break: normal;
                        display: inline-flex;
                        align-items: center;
                      ">
                      {{ $t("insights.Strategic_Alignment") }}
                     
                    </span>
                  </div>
                  <div style="min-width: 35px; text-align: right">
                    <div>
                      <span v-if="scope.$index == 0 && datatable[0].length > 2" class="fw-700" style="
                          font-size: 13px;
                          color: #747474;
                          word-break: normal;
                        ">{{
                          showGroup == "cohorts" ? "" : scope.row[1]
                        }}</span>
                      <span v-else-if="
                        scope.row[1] == -999 && datatable[0].length > 2
                      " class="fw-700" style="
                          margin-left: 25px;
                          font-size: 15px;
                          color: 747474;
                          word-break: normal;
                        ">-</span>
                      <span v-else-if="
                        categoryMaster[scope.row[0]] ||
                        scope.row[0] == 'nps' ||
                        scope.row[0] == 'set1' ||
                        scope.row[0] == 'engagement' ||
                        scope.row[0] == 'strategic_alignment'
                      " class="fw-700 hover-tooltip flex-mid ml-auto">
                        <el-tooltip v-if="scope.row[0] == 'nps'" effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{ $t("insights.Net_Promotor_Score_is")
                            }}<br /><br />
                            {{ $t("insights.Net_Promoter_Net_Promoter") }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-if="scope.row[0] == 'engagement'" effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{ $t("insights.Engagement_Score_is")
                            }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-else-if="scope.row[0] == 'strategic_alignment'" effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{ $t("insights.Strategic_Alignment_is")
                            }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-else-if="scope.row[0] == 'set1'" effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{ $t("insights.A_collection_of_indexes")
                            }}<br /><br />
                            {{ $t("insights.The_Culture_Index_is")
                            }}<br /><br />
                            {{ $t("insights.The_Employee_Resilience_Index")
                            }}<br /><br />
                            {{ $t("insights.The_WHO_5_Index_from")
                            }}<br /><br />
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-else-if="
                          categoryMaster[scope.row[0]] && categoryMaster[scope.row[0]].category ==
                          'Ambassadorship'
                        " effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{ $t("insights.Loyal_employees_who_are") }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-else-if="
                          categoryMaster[scope.row[0]] && categoryMaster[scope.row[0]].category ==
                          'Company Alignment'
                        " effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{ $t("insights.Company_alignment_provides") }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-else-if="
                          categoryMaster[scope.row[0]] && categoryMaster[scope.row[0]].category ==
                          'Feedback'
                        " effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{ $t("insights.Feedback_has_significant") }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-else-if="
                          categoryMaster[scope.row[0]] && categoryMaster[scope.row[0]].category ==
                          'Introspection'
                        " effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            <a class="style-link"
                              href="https://www.sciencedirect.com/science/article/abs/pii/S1053482215000091"
                              target="_blank">
                              {{ $t("insights.Recent_studies") }}
                            </a>
                            {{ $t("insights.focus_on_how_mindset") }}
                            <i>"{{
                              $t("insights.Social_educational_and")
                            }}"</i><br /><br />
                            {{ $t("insights.Managers_play_an_importan") }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-else-if="
                          categoryMaster[scope.row[0]] && categoryMaster[scope.row[0]].category ==
                          'Personal Growth'
                        " effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{
                              $t(
                                "insights.Employees_need_to_feel_that_they_are"
                              )
                            }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-else-if="
                          categoryMaster[scope.row[0]] && categoryMaster[scope.row[0]].category ==
                          'Recognition'
                        " effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{
                              $t(
                                "insights.Employees_need_to_feel_taht_their_work"
                              )
                            }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-else-if="
                          categoryMaster[scope.row[0]] && categoryMaster[scope.row[0]].category ==
                          'Relationship with Colleagues'
                        " effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{ $t("insights.The_support_that_employees") }}
                            <a class="style-link" href="https://psycnet.apa.org/record/2007-16921-006"
                              target="_blank">
                              {{ $t("insights.Studies") }}
                            </a>
                            {{ $t("insights.show_that_satisfaction_with")
                            }}<br /><br />
                            {{ $t("insights.The") }}
                            <a class="style-link"
                              href="https://store.hbr.org/product/new-approach-to-keeping-your-best-on-board/u0704b?sku=U0704B-PDF-ENG"
                              target="_blank">
                              {{ $t("insights.more_embedded_a_person") }}
                            </a>
                            {{ $t("insights.is_in_their_job") }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-else-if="
                          categoryMaster[scope.row[0]] && categoryMaster[scope.row[0]].category ==
                          'Relationship with Manager'
                        " effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{ $t("insights.Managers_set_standards_for") }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-else-if="
                          categoryMaster[scope.row[0]] && categoryMaster[scope.row[0]].category ==
                          'Satisfaction'
                        " effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{ $t("insights.Apart_from_pay_challenging") }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                        <el-tooltip v-else-if="
                          categoryMaster[scope.row[0]] && categoryMaster[scope.row[0]].category ==
                          'Wellness'
                        " effect="dark" placement="top">
                          <div class="tooltipStyle" slot="content">
                            {{ $t("insights.Employees_need_work_life") }}
                          </div>
                          <img :src="getImgUrl('help_outline-16px')" />
                        </el-tooltip>
                      </span>
                      <span v-else-if="datatable[0].length !== 2" class="fw-700" style="
                          font-size: 13px;
                          color: #000000;
                          word-break: normal;
                        ">{{ renderTotalData(scope.row) }}</span>
                    </div>
                  </div>
                  <div class="ml-6 flex-mid" style="width: 24px; height: 24px" v-if="
                    categoryMaster[scope.row[0]] ||
                      scope.row[0] == 'nps' ||
                      scope.row[0] == 'set1' ||
                      scope.row[0] == 'engagement' ||
                      scope.row[0] == 'strategic_alignment'
                      ? false
                      : true
                  ">
                    <!-- Move the el-tooltip here to only wrap the chart icon -->
                    <el-tooltip effect="light" :disabled="scope.row[0] == 'NO. OF RESPONSES' ||
                        categoryMaster[scope.row[0]] ||
                        scope.row[0] == 'nps' ||
                        scope.row[0] == 'set1' ||
                        scope.row[0] == 'engagement' ||
                        scope.row[0] == 'strategic_alignment'
                        ? true
                        : false
                      ">
                      <div slot="content">
                        <div :class="`content-container-insightsReport`" :style="{ widthOfPopup, maxWidth: '640px' }">
                          <div class="flex-center fs-11">
                            <div class="fw-900 fc-2B2B2B mr-auto">
                              {{ $t("insights.SCORE_HISTORY") }}
                            </div>
                            <div class="fw-700 fc-2B2B2B mr-4">
                              {{ $t("insights.Max_Change") }}
                            </div>
                            <div :class="`fw-700 fc-${getColorChange()}`">
                              {{ chartMaxChange > 0 ? "+" : ""
                              }}{{ $utils("addCommasInNumber", chartMaxChange)
                              }}{{
                                questionType[scope.row[0]] &&
                                  (questionType[scope.row[0]] == "NPS" ||
                                    questionType[scope.row[0]] == "eNPS")
                                  ? ""
                                  : "%"
                              }}
                            </div>
                          </div>
                          <div class="pt-20 relative" style="height: 140px">
                            <div class="center mt-10 mb-40 pt-10 pb-40" v-if="hoverData.loading">
                              <loading-even></loading-even>
                            </div>
                            <canvas :ref="scope.row[0]" height="180px;" class=""></canvas>
                          </div>
                          <div class="fs-11 fc-2B2B2B opa-03 right">
                            {{ $t("insights.Most_Recent") }}
                          </div>
                        </div>
                      </div>
                      <div class="icons-chart flex-center" v-if="
                        scope.row[0] == 'NO. OF RESPONSES' ||
                          categoryMaster[scope.row[0]] ||
                          scope.row[0] == 'nps' ||
                          scope.row[0] == 'set1' ||
                          scope.row[0] == 'engagement' ||
                          scope.row[0] == 'strategic_alignment'
                          ? false
                          : true
                      " @mouseover.prevent="showingHistoryChart(scope)">
                        <div class="line line-1"></div>
                        <div class="line line-2"></div>
                        <div class="line line-3"></div>
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="datatable.length > 0 && datatable[0] && index > 0" align="center" v-for="(column, index) in datatable[0]" :index="index" :key="index"
            :column-key="column" :label="column" label-class-name="fixedTable" :render-header="renderPhaseHeader">
            <template slot-scope="scope">
              <div class="flex-column">
                <span v-if="scope.$index == 0" class="txtStyle">{{
                  scope.row[index] == "*" ? "" : scope.row[index]
                  }}</span>
                <!-- <span v-else-if="scope.$index != 0 && scope.row[index] > 0 && scope.row[index] <= 25" class="txtStyle">{{scope.row[index]}}%</span>
                  <span v-else-if="scope.$index != 0 && scope.row[index] > 25 && scope.row[index] <= 50" class="txtStyle">{{scope.row[index]}}%</span>
                <span v-else-if="scope.$index != 0 && scope.row[index] > 50 && scope.row[index] < 70" class="txtStyle">{{scope.row[index]}}%</span>-->
                <span v-else-if="scope.$index != 0 && scope.row[index] == '*'" class="txtStyle"></span>
                <span v-else-if="scope.row[index] === undefined" class="txtStyle"></span>
                <span v-else class="txtStyle">{{
                  renderCellData(scope.row, index)
                  }}</span>
              </div>
            </template>
          </el-table-column>
          </el-table>
          <div v-else key="report-loading" class="report-loading-shell" role="status" aria-live="polite">
            <div class="report-loading-table" aria-hidden="true">
              <div class="report-skeleton-headline-row">
                <div class="text-skeleton report-skeleton-quarter"></div>
                <div class="report-skeleton-chip-row">
                  <div
                    v-for="column in loadingSkeletonColumnCount"
                    :key="`report-loading-chip-${column}`"
                    class="text-skeleton report-skeleton-chip"
                  ></div>
                </div>
              </div>
              <div class="report-skeleton-header-row">
                <div class="text-skeleton report-skeleton-axis"></div>
                <div
                  class="report-skeleton-header-values"
                  :style="{ gridTemplateColumns: `repeat(${loadingSkeletonColumnCount}, minmax(0, 1fr))` }"
                >
                  <div
                    v-for="column in loadingSkeletonColumnCount"
                    :key="`report-loading-header-${column}`"
                    class="text-skeleton report-skeleton-header-cell"
                  ></div>
                </div>
              </div>
              <div
                v-for="(row, rowIndex) in loadingSkeletonRows"
                :key="`report-loading-row-${rowIndex}`"
                class="report-skeleton-row"
              >
                <div
                  class="text-skeleton report-skeleton-label"
                  :style="{ width: row.labelWidth }"
                ></div>
                <div
                  class="report-skeleton-values"
                  :style="{ gridTemplateColumns: `repeat(${loadingSkeletonColumnCount}, minmax(0, 1fr))` }"
                >
                  <div
                    v-for="column in loadingSkeletonColumnCount"
                    :key="`report-loading-cell-${rowIndex}-${column}`"
                    class="text-skeleton report-skeleton-cell"
                    :class="{ 'report-skeleton-cell-soft': row.soft }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <download-progress :active="showSnackbar"></download-progress>
    <el-dialog class="txtHeaderModal" :title="title_dialog" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item>
          <el-col :span="11">
            <span>{{ $t("insights.Before") }}</span>
            <el-select v-model="form.before" style="width: 100%" placeholder="Select Quarter"
              @change="handleQuarterBefore">
              <el-option v-for="item in quarterOptionModal" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="12">
            <span>{{ $t("insights.After") }}</span>
            <el-select v-model="form.after" style="width: 100%" placeholder="Select Quarter">
              <el-option v-for="item in quarterOptionModalAfter" :key="item.id" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCompare">{{
          $t("insights.Cancel")
          }}</el-button>
        <el-button type="info" @click="compareQuarter">{{
          $t("insights.Compare")
          }}</el-button>
      </span>
    </el-dialog>

    <!-- Strategic Alignment Modal -->
    <el-dialog class="strategic-alignment-modal" :visible.sync="showStrategicAlignmentModal" width="1000px" top="5vh"
      :title="$t('insights.Strategic_Alignment_Details')">
      <div class="modal-content" v-loading="loadingStrategicAlignment">
        <template v-if="!loadingStrategicAlignment">
          <div class="header flex-center">
            <span>
              {{ $t("insights.Strategic_Alignment_Breakdown") }}
              <span v-if="selectTeam && selectTeam !== 'all'" class="team-name">
                - {{ getTeamName(selectTeam) }}
              </span>
              <span v-else class="team-name">
                - All Teams
              </span>
              <span class="time-period">
                ({{ strategicAlignmentQuarterName || quarterSelected.name }})
              </span>
            </span>
          </div>

          <div class="global-legend">
            <div class="legend-items">
              <div class="legend-item">
                <div class="legend-color strongly-agree"></div>
                <span>Strongly Agree</span>
              </div>
              <div class="legend-item">
                <div class="legend-color agree"></div>
                <span>Agree</span>
              </div>
              <div class="legend-item">
                <div class="legend-color neutral"></div>
                <span>Neutral</span>
              </div>
              <div class="legend-item">
                <div class="legend-color disagree"></div>
                <span>Disagree</span>
              </div>
              <div class="legend-item">
                <div class="legend-color strongly-disagree"></div>
                <span>Strongly Disagree</span>
              </div>
            </div>
          </div>

          <div class="body">
            <!-- <div v-if="selectTeam && selectTeam !== 'all'" class="segment-note">
              Showing data for the selected team from {{ quarterSelected.name }}. Data is based on the most recent responses within this time period.
            </div>
            
            <div v-else class="segment-note">
              Showing aggregated data across all teams from {{ quarterSelected.name }}. Data is based on the most recent responses within this time period.
            </div> -->
            
            <div v-for="(segment, segmentIndex) in strategicAlignmentSegments" :key="segmentIndex" class="segment-item">
              <div class="segment-header">
                {{ segment.name }}
              </div>
              <div class="questions-container">
                <div v-for="(question, questionIndex) in segment.questions" :key="question.id" class="question-item"
                  :class="{ 'question-item-divider': questionIndex < segment.questions.length - 1 }">
                  <div class="question-header">
                    <div class="question-text-wrapper">
                      <span class="question-text">{{ question.text }}</span>
                      <div class="score-container" v-if="question.score && question.totalResponses">
                        <span class="question-score">{{ question.score }}</span>
                        <span class="response-count">{{ question.totalResponses }} responses</span>
                      </div>
                    </div>
                  </div>
                  <div class="response-breakdown" v-if="question.responses && question.totalResponses">
                    <div class="bar-container">
                      <div 
                        v-for="(value, key) in question.responses" 
                        :key="key"
                        class="bar-segment"
                        :class="getResponseClass(key)"
                        :style="{ width: ((value / question.totalResponses) * 100) + '%' }"
                      >
                        <span 
                          v-if="((value / question.totalResponses) * 100) >= 4"
                          class="bar-label"
                        >
                          {{ Math.round((value / question.totalResponses) * 1000) / 10 }}
                        </span>
                        <el-tooltip
                          v-else
                          :content="`${Math.round((value / question.totalResponses) * 1000) / 10}%`"
                          placement="top"
                          :show-after="0"
                        >
                          <span class="bar-label-hidden"></span>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <div class="no-data-message" v-else>
                    <span class="no-data-text">No response data available for this time period</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </el-dialog>

    <!-- Culture Index Modal -->
    <el-dialog class="strategic-alignment-modal culture-modal" :visible.sync="showCultureModal" width="1000px" top="5vh"
      :title="$t('insights.Culture_Index_Details')">
      <div class="modal-content" v-loading="loadingCulture">
        <template v-if="!loadingCulture">
          <div class="header flex-center">
            <span>
              {{ $t("insights.Culture_Index_Breakdown") }}
              <span v-if="selectTeam && selectTeam !== 'all'" class="team-name">
                - {{ getTeamName(selectTeam) }}
              </span>
              <span v-else class="team-name">
                - All Teams
              </span>
              <span class="time-period">
                ({{ cultureQuarterName || quarterSelected.name }})
              </span>
            </span>
          </div>

          <div class="global-legend" v-if="cultureHasMultipleChoice">
            <div class="legend-items">
              <div class="legend-item">
                <div class="legend-color strongly-agree"></div>
                <span>Strongly Agree</span>
              </div>
              <div class="legend-item">
                <div class="legend-color agree"></div>
                <span>Agree</span>
              </div>
              <div class="legend-item">
                <div class="legend-color neutral"></div>
                <span>Neutral</span>
              </div>
              <div class="legend-item">
                <div class="legend-color disagree"></div>
                <span>Disagree</span>
              </div>
              <div class="legend-item">
                <div class="legend-color strongly-disagree"></div>
                <span>Strongly Disagree</span>
              </div>
            </div>
          </div>
          <div class="global-legend" v-if="cultureHasScale">
            <div class="legend-items">
              <div class="legend-item">
                <div class="legend-color scale-promoter"></div>
                <span>Promoter (9-10)</span>
              </div>
              <div class="legend-item">
                <div class="legend-color scale-high"></div>
                <span>High (7-8)</span>
              </div>
              <div class="legend-item">
                <div class="legend-color scale-moderate"></div>
                <span>Moderate (4-6)</span>
              </div>
              <div class="legend-item">
                <div class="legend-color scale-low"></div>
                <span>Low (1-3)</span>
              </div>
              <div class="legend-item">
                <div class="legend-color scale-zero"></div>
                <span>Zero (0)</span>
              </div>
            </div>
          </div>

          <div class="body">
            <div v-for="(segment, segmentIndex) in cultureSegments" :key="segmentIndex" class="segment-item">
              <div class="segment-header">
                {{ segment.name }}
              </div>
              <div class="questions-container">
                <div v-for="(question, questionIndex) in segment.questions" :key="question.id" class="question-item"
                  :class="{ 'question-item-divider': questionIndex < segment.questions.length - 1 }">
                  <div class="question-header">
                    <div class="question-text-wrapper">
                      <span class="question-text">{{ question.text }}</span>
                      <div class="score-container" v-if="question.score !== undefined && question.totalResponses">
                        <span class="question-score">{{ question.score }}</span>
                        <span class="response-count">{{ question.totalResponses }} responses</span>
                      </div>
                    </div>
                  </div>
                  <div class="response-breakdown" v-if="question.responses && question.totalResponses">
                    <div class="bar-container">
                      <div
                        v-for="(value, key) in question.responses"
                        :key="key"
                        class="bar-segment"
                        :class="question.questionType === 'Scale' ? getResponseClassScale(key) : getResponseClass(key)"
                        :style="{ width: ((value / question.totalResponses) * 100) + '%' }"
                      >
                        <span
                          v-if="((value / question.totalResponses) * 100) >= 4"
                          class="bar-label"
                        >
                          {{ Math.round((value / question.totalResponses) * 1000) / 10 }}
                        </span>
                        <el-tooltip
                          v-else
                          :content="`${Math.round((value / question.totalResponses) * 1000) / 10}%`"
                          placement="top"
                          :show-after="0"
                        >
                          <span class="bar-label-hidden"></span>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <div class="no-data-message" v-else>
                    <span class="no-data-text">No response data available for this time period</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </el-dialog>

    <!-- WHO-5 Modal -->
    <el-dialog class="who-5-modal" :visible.sync="showWHO5Modal" width="1000px" top="5vh"
      :title="$t('insights.WHO_5_Details')">
      <div class="modal-content" v-loading="loadingWHO5">
        <template v-if="!loadingWHO5">
          <div class="header flex-center">
            <span>
              {{ $t("insights.WHO_5_Breakdown") }}
              <span v-if="selectTeam && selectTeam !== 'all'" class="team-name">
                - {{ getTeamName(selectTeam) }}
              </span>
              <span v-else class="team-name">
                - All Teams
              </span>
              <span class="time-period">
                ({{ who5QuarterName || quarterSelected.name }})
              </span>
            </span>
          </div>

          <div class="global-legend">
            <div class="legend-items">
              <div class="legend-item">
                <div class="legend-color all-time"></div>
                <span>All of the time</span>
              </div>
              <div class="legend-item">
                <div class="legend-color most-time"></div>
                <span>Most of the time</span>
              </div>
              <div class="legend-item">
                <div class="legend-color more-half"></div>
                <span>More than half of the time</span>
              </div>
              <div class="legend-item">
                <div class="legend-color less-half"></div>
                <span>Less than half of the time</span>
              </div>
              <div class="legend-item">
                <div class="legend-color some-time"></div>
                <span>Some of the time</span>
              </div>
              <div class="legend-item">
                <div class="legend-color no-time"></div>
                <span>At no time</span>
              </div>
            </div>
          </div>

          <div class="body">
            <div v-for="(segment, segmentIndex) in who5Segments" :key="segmentIndex" class="segment-item">
              <div class="segment-header">
                {{ segment.name }}
              </div>
              <div class="questions-container">
                <div v-for="(question, questionIndex) in segment.questions" :key="question.id" class="question-item"
                  :class="{ 'question-item-divider': questionIndex < segment.questions.length - 1 }">
                  <div class="question-header">
                    <div class="question-text-wrapper">
                      <span class="question-text">{{ question.text }}</span>
                      <div class="score-container">
                        <span class="question-score">{{ question.score }}</span>
                        <span v-if="question.totalResponses" class="response-count">{{ question.totalResponses }}
                          responses</span>
                      </div>
                    </div>
                  </div>
                  <div class="response-breakdown">
                    <div class="bar-container">
                      <div 
                        v-for="(value, key) in question.responses" 
                        :key="key"
                        class="bar-segment"
                        :class="getResponseClassWHO5(key)"
                        :style="{ width: ((value / question.totalResponses) * 100) + '%' }"
                      >
                        <span 
                          v-if="((value / question.totalResponses) * 100) >= 4"
                          class="bar-label"
                        >
                          {{ Math.round((value / question.totalResponses) * 1000) / 10 }}
                        </span>
                        <el-tooltip
                          v-else
                          :content="`${Math.round((value / question.totalResponses) * 1000) / 10}%`"
                          placement="top"
                          :show-after="0"
                        >
                          <span class="bar-label-hidden"></span>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </el-dialog>

    <!-- eNPS/NPS Modal -->
    <el-dialog class="nps-modal" :visible.sync="showNPSModal" width="1000px" top="5vh"
      :title="$t('insights.NPS_Details')">
      <div class="modal-content" v-loading="loadingNPS">
        <template v-if="!loadingNPS">
          <div class="header flex-center">
            <span>
              {{ selectedMetric }} {{ $t("insights.Score_Distribution") }}
              <span v-if="selectTeam && selectTeam !== 'all'" class="team-name">
                - {{ getTeamName(selectTeam) }}
              </span>
              <span v-else class="team-name">
                - All Teams
              </span>
              <span class="time-period">
                ({{ quarterSelected.name }})
              </span>
            </span>
          </div>
          
          <!-- <div class="period-subtitle">
            <span v-if="selectTeam && selectTeam !== 'all'">
              Showing data for {{ getTeamName(selectTeam) }} from {{ quarterSelected.name }}. Data is based on responses within this time period.
            </span>
            <span v-else>
              Showing aggregated data across all teams from {{ quarterSelected.name }}. Data is based on responses within this time period.
            </span>
          </div> -->

          <div class="global-legend">
            <div class="legend-items">
              <div v-if="selectedMetric === 'eNPS' || selectedMetric === 'NPS'" class="legend-item">
                <div class="legend-color promoter"></div>
                <span>Promoters (9-10)</span>
              </div>
              <div v-if="selectedMetric === 'eNPS' || selectedMetric === 'NPS'" class="legend-item">
                <div class="legend-color passive"></div>
                <span>Passives (7-8)</span>
              </div>
              <div v-if="selectedMetric === 'eNPS' || selectedMetric === 'NPS'" class="legend-item">
                <div class="legend-color detractor"></div>
                <span>Detractors (0-6)</span>
              </div>
            </div>
          </div>

          <div class="body">
            <div v-if="npsData" class="score-summary">
              <div class="score-box">
                <div class="score-value" :class="getScoreClass(npsData.total)">
                  {{ npsData.total > 0 ? '+' + npsData.total : npsData.total }}
                </div>
                <div class="score-label">Overall Score</div>
              </div>
              <div class="distribution-boxes">
                <div class="dist-box promoters">
                  <div class="dist-value">{{ npsData.percent.promotors }}%</div>
                  <div class="dist-count">({{ npsData.promotors }} responses)</div>
                  <div class="dist-label">Promoters</div>
                </div>
                <div class="dist-box passives">
                  <div class="dist-value">{{ npsData.percent.passives }}%</div>
                  <div class="dist-count">({{ npsData.passives }} responses)</div>
                  <div class="dist-label">Passives</div>
                </div>
                <div class="dist-box detractors">
                  <div class="dist-value">{{ npsData.percent.detractors }}%</div>
                  <div class="dist-count">({{ npsData.detractors }} responses)</div>
                  <div class="dist-label">Detractors</div>
                </div>
              </div>
            </div>

            <div v-if="npsData" class="score-distribution">
              <div class="section-title">Detailed Score Distribution</div>
              <div class="horizontal-histogram">
                <div class="histogram-container">
                  <div class="score-bars">
                    <div v-for="score in getScoreRange()" :key="score" class="score-column">
                      <div v-if="getScoreCount(score) > 0" class="histogram-bar" 
                         :style="{
                           height: getScoreHeight(score),
                           backgroundColor: getScoreColor(score)
                         }"
                         :data-count="getScoreCount(score)">
                        <span v-if="getScoreCount(score) > 0">{{ getScoreCount(score) }}</span>
                      </div>
                      <div class="external-count">{{ getScoreCount(score) }}</div>
                      <div class="score-label">{{ score }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="benchmark-section" v-if="npsData && npsData.type && npsData.total !== benchmarkScore(npsData.type.toLowerCase())">
              <div class="benchmark-box" :class="npsData.total > benchmarkScore(npsData.type.toLowerCase()) ? 'positive' : 'negative'">
                <div class="benchmark-value">
                  {{ Math.abs(npsData.total - benchmarkScore(npsData.type.toLowerCase())) }} points 
                  {{ npsData.total > benchmarkScore(npsData.type.toLowerCase()) ? 'above' : 'below' }} benchmark
                </div>
                <div class="benchmark-label">
                  Industry benchmark: {{ benchmarkScore(npsData.type.toLowerCase()) }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showNPSModal = false" class="btn-gray-outline">{{ $t("insights.Close") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { format, getQuarter } from 'date-fns';

const createDefaultWho5Segments = () => ([
  {
    name: "WHO-5 Well-Being Index",
    questions: [
      {
        id: "-MdMv_XgThL0o2iunlhE",
        text: "In the past 2 weeks, I have felt cheerful and in good spirits",
        score: 0,
        responses: {
          "All of the time": 0,
          "Most of the time": 0,
          "More than half of the time": 0,
          "Less than half of the time": 0,
          "Some of the time": 0,
          "At no time": 0
        },
        totalResponses: 0
      },
      {
        id: "-MdMw8kfpZtxnppGUA1f",
        text: "In the past 2 weeks, I have felt calm and relaxed",
        score: 0,
        responses: {
          "All of the time": 0,
          "Most of the time": 0,
          "More than half of the time": 0,
          "Less than half of the time": 0,
          "Some of the time": 0,
          "At no time": 0
        },
        totalResponses: 0
      },
      {
        id: "-MdMyavdF-YvuyzW6cA5",
        text: "In the past 2 weeks, I have felt active and vigorous",
        score: 0,
        responses: {
          "All of the time": 0,
          "Most of the time": 0,
          "More than half of the time": 0,
          "Less than half of the time": 0,
          "Some of the time": 0,
          "At no time": 0
        },
        totalResponses: 0
      },
      {
        id: "-MdMz-TodEXbj3AC68oP",
        text: "In the past 2 weeks, I woke up feeling fresh and rested",
        score: 0,
        responses: {
          "All of the time": 0,
          "Most of the time": 0,
          "More than half of the time": 0,
          "Less than half of the time": 0,
          "Some of the time": 0,
          "At no time": 0
        },
        totalResponses: 0
      },
      {
        id: "-MdMzwfySVTjhOAGoxTP",
        text: "In the past 2 weeks, my daily life has been filled with things that interest me",
        score: 0,
        responses: {
          "All of the time": 0,
          "Most of the time": 0,
          "More than half of the time": 0,
          "Less than half of the time": 0,
          "Some of the time": 0,
          "At no time": 0
        },
        totalResponses: 0
      }
    ]
  }
]);

export default {
  name: "report",
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  created() {
    this.initializeReportView();
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"] || {};
    },
    optionsTeam() {
      return this.$store.getters["team/teamsall"] || [];
    },
    optionsCohort() {
      return this.$store.getters["insightsCohorts/optionsCohort"] || [];
    },
    datatable() {
      const data = this.$store.getters["report/datatable"] || [];
      if (data.length > 0) {
        return data.filter(row =>
          !(row[0] && this.questionType[row[0]] === 'Variance')
        );
      }
      return data;
    },
    teamkeys() {
      return this.$store.getters["report/teamkeys"] || [];
    },
    cohortkeys() {
      return this.$store.getters["report/cohortkeys"] || [];
    },
    categoryMaster() {
      return this.$store.getters["report/categoryMaster"] || {};
    },
    questionMaster() {
      return this.$store.getters["report/questionMaster"] || {};
    },
    quarterSelected() {
      return this.$store.getters["report/quarterSelected"] || {};
    },
    quarterOption() {
      return this.$store.getters["report/quarterOption"] || [];
    },
    quarterOptionModal() {
      return this.$store.getters["report/quarterOptionModal"] || [];
    },
    teamsetup() {
      return this.$store.getters["report/teamsetup"] || [];
    },
    questionType() {
      return this.$store.getters["report/questionType"] || [];
    },
    showSnackbar() {
      return this.$store.getters["report/showSnackbar"];
    },
    chartData() {
      return this.$store.getters["report/chartData"] || [];
    },
    chartLabel() {
      return this.$store.getters["report/chartLabel"] || [];
    },
    chartMaxChange() {
      return this.$store.getters["report/chartMaxChange"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    cultureHasScale() {
      if (!this.cultureSegments || !this.cultureSegments.length) return false;
      return this.cultureSegments.some(seg =>
        seg.questions && seg.questions.some(q => q.questionType === 'Scale')
      );
    },
    cultureHasMultipleChoice() {
      if (!this.cultureSegments || !this.cultureSegments.length) return true;
      return this.cultureSegments.some(seg =>
        seg.questions && seg.questions.some(q => q.questionType !== 'Scale')
      );
    },
    loadingSkeletonColumnCount() {
      return this.showGroup === "cohorts" ? 3 : 4;
    },
    loadingSkeletonRows() {
      return [
        { labelWidth: "200px", soft: false },
        { labelWidth: "184px", soft: false },
        { labelWidth: "232px", soft: true },
        { labelWidth: "172px", soft: true },
        { labelWidth: "214px", soft: true },
        { labelWidth: "188px", soft: true },
      ];
    },
  },
  watch: {
    datatable: {
      handler(data) {
        if (Array.isArray(data) && data.length > 0) {
          this.loadingDatatable = true;
        }
      },
    },
    optionsTeam() {
      if (this.optionsTeam.length > 0) {
        this.selectTeam =
          this.user.user_type == "leadership" ? this.user.team : "all";
      }
    },
    quarterSelected: {
      deep: true,
      handler(newVal, oldVal) {
        // When quarter changes, update modal data if open, otherwise just clear cached data
        
        if (this.showNPSModal && this.lastNPSRow) {
          // If the NPS modal is open, refresh its data with the new quarter
          this.openNPSModal(this.lastNPSRow);
        } else {
          // Otherwise just clear cached data
          this.npsData = null;
        }
      }
    },
    typeChecked(value) {
      document.getElementById("sortby_reportcard").innerHTML =
        "Highest Success Score";
      this.$store.commit("report/setsortBy", "highest");

      if (value) {
        if (this.user.user_type !== "leadership") {
          this.selectTeam = "all";
        } else {
          this.selectTeam = this.user.team;
        }
        this.showGroup = "teams";
        this.loadReportTable(this.selectTeam);
      } else {
        this.selectTeam = "all";
        this.showGroup = "cohorts";
        this.loadReportTable(this.selectTeam);
      }
    },
    chartData() {
      if (this.RanderTooltipBarChart) {
        this.RanderTooltipBarChart.destroy();
      }
      let chartLabel = this.chartLabel; // TODO: Add data to chart here!
      let chartData = this.chartData; // TODO: Add data to chart here!
      let arrColor = [];
      for (const x in chartData) {
        arrColor.push(
          this.detectBackgroundColorChart(this.rowSelected[0], chartData[x])
        );
      }
      const convertedArray = chartData.map((item) => {
        if (typeof item === "number" && item === 0) {
          return "0.1415926535897932384626433";
        }
        return item;
      });
      const chartBarColor = arrColor;
      const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));

      var tooltipBarChart = this.$refs[this.rowSelected[0]];
      const width = (chartBarColor.length * 48 || 0) + 165;
      this.widthOfPopup = `width: ${width}px;`;
      options.plugins.datalabels = {
        color: "#000",
        display: true,
        font: {
          weight: "bold",
          size: 12,
        },
      };
      let type = this.getTypeOfData(this.rowSelected);
      // nothing, value, percentage
      if (type == "percentage") {
        options.plugins.datalabels = {
          formatter(value) {
            if (value == "0.1415926535897932384626433") {
              return '';
            }
            return value + "%";
          },
        };
      } else {
        options.plugins.datalabels = {
          formatter: function (value, context) {
            if (value == "0.1415926535897932384626433") {
              return "0";
            }
            return value;
          },
        };
      }
      options.plugins.tooltip = {
        enabled: false,
      };
      options.layout = {
        padding: {
          top: 20,
        },
      };
      options.scales = {
        y: {
          grid: {
            display: true,
            drawBorder: true,
          },
          ticks: {
            display: false,
            beginAtZero: true,
          },
        },
      };
      if (tooltipBarChart) {
        this.hoverData.hover = false;
        this.hoverData.loading = false;
        const tooltipBarChartData = {
          labels: chartLabel,
          datasets: [
            {
              label: "SCORE",
              data: convertedArray,
              backgroundColor: chartBarColor,
              borderColor: "#70707066",
              borderWidth: 1,
            },
          ],
        };
        this.RanderTooltipBarChart = new Chart(
          tooltipBarChart[0].getContext("2d"),
          {
            plugins: [ChartDataLabels],
            type: "bar",
            data: tooltipBarChartData,
            options: options,
          }
        );
      }
    },
  },
  data() {
    return {
      RanderTooltipBarChart: "",
      loadingDatatable: false,
      selectTeam: "",
      MaxHeight: window.innerHeight - 30,
      title_dialog: "",
      formLabelWidth: "140px",
      dialogFormVisible: false,
      quarterOptionModalAfter: [],
      form: {
        before: "",
        after: "",
      },
      showGroup: "teams",
      isInfinity: true,
      hoverData: {
        loading: false,
        hover: false,
        change: 12500,
        data: {
          labels: ["Q1 2021", "Q2 2021", "Q3 2021", "Q4 2021"],
          value: [-18, 16, 86, 100],
        },
      },
      typeChecked: true,
      rowSelected: [],
      questionSelected: "",
      idSelected: "",
      widthOfPopup: "width: 480px;",
      varianceThreshold: 70,
      showStrategicAlignmentModal: false,
      loadingStrategicAlignment: false,
      strategicAlignmentOverallScore: 0,
      strategicAlignmentQuarterName: '',
      who5QuarterName: '',
      showWHO5Modal: false,
      loadingWHO5: false,
      showNPSModal: false,
      loadingNPS: false,
      selectedMetric: '',
      npsData: {
        total: 0,
        promotors: 0,
        passives: 0,
        detractors: 0,
        percent: {
          promotors: 0,
          passives: 0,
          detractors: 0
        },
        allScores: []
      },
      lastNPSRow: null,
      who5Segments: createDefaultWho5Segments(),
      strategicAlignmentSegments: [
        {
          name: "Understanding & Clarity (25% of index)",
          questions: [
            {
              id: "-OGSfTQqu71fi7f67Ztm",
              text: "I understand how my team's priorities connect to the company's overall direction"
            },
            {
              id: "-OGSgDcIZeg9vJ6JTUYJ",
              text: "My team's current priorities are clear and well-communicated"
            }
          ]
        },
        {
          name: "Execution & Confidence (25%)",
          questions: [
            {
              id: "-OGSh6nBCPhmZVVcSvO6",
              text: "I am confident my team will achieve its current priorities"
            },
            {
              id: "-OGSi-yigX4U4lSn8z7h",
              text: "I understand what success looks like for my team's priorities"
            }
          ]
        },
        {
          name: "Resource & Support (25%)",
          questions: [
            {
              id: "-OGSiV8s4nrPMhxK_zAe",
              text: "My team has the resources needed to achieve our priorities"
            },
            {
              id: "-OGSj6iv4BiFfUlwg290",
              text: "I know where to get help if obstacles arise in achieving our priorities"
            }
          ]
        },
        {
          name: "Impact & Contribution (25%)",
          questions: [
            {
              id: "-OGSjePG4WFU8A4YH0iB",
              text: "My daily work meaningfully contributes to my team's key objectives"
            },
            {
              id: "-OGSmPA41e8em6xyRJ-5",
              text: "I can see how my team's success impacts overall company success"
            }
          ]
        }
      ],
      // Culture Index Modal
      showCultureModal: false,
      loadingCulture: false,
      cultureQuarterName: "",
      cultureSegments: [
        {
          name: "Culture Index Questions",
          questions: []  // Will be populated dynamically from questionSet3
        }
      ]
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.MaxHeight = window.innerHeight - 30;
    });
    if (this.optionsTeam.length > 0 && this.selectTeam == "") {
      this.selectTeam =
        this.user.user_type == "leadership" ? this.user.team : "all";
    }
  },
  methods: {
    beginTableLoading() {
      this.loadingDatatable = false;
    },
    loadReportTable(teamKey = this.selectTeam) {
      const team = teamKey && teamKey !== "all" ? teamKey : "";
      this.beginTableLoading();
      if (this.showGroup == "teams") {
        return this.$store.dispatch("report/getDataTable", team);
      }
      return this.$store.dispatch("report/getDataTableCohorts", team);
    },
    async initializeReportView() {
      try {
        this.beginTableLoading();
        this.$store.dispatch("report/getQuarter");
        this.$store.dispatch("team/getTeamsOptions", this.user);
        this.$store.dispatch("insightsCohorts/getOptionsCohort", this.user);

        await Promise.all([
          this.$store.dispatch("report/getQuestionMaster"),
          this.$store.dispatch("report/getKeys"),
          this.$store.dispatch("report/getOrganization"),
        ]);

        await this.loadReportTable(
          this.user && this.user.user_type == "leadership"
            ? this.user.team || ""
            : "all"
        );
      } catch (error) {
        console.error("Failed to initialize report view:", error);
      }
    },
    showRowData(row, column, event) {
      // Don't open modals when in COHORTS view
      if (this.showGroup === "cohorts") {
        return;
      }
      
      // Check if this is a WHO-5 row
      if (row[0] && this.questionType[row[0]] === 'WHO-5') {
        this.openWHO5Modal();
        return;
      }
      
      // Check if this is a Strategic Alignment row
      if (row[0] && this.questionType[row[0]] === 'Index') {
        this.openStrategicAlignmentModal();
        return;
      }

      // Check if this is a Culture row
      if (row[0] && this.questionType[row[0]] === 'Culture') {
        this.openCultureModal();
        return;
      }

      // Check if this is an NPS/eNPS row
      if (row[0] && (this.questionType[row[0]] === 'NPS' || this.questionType[row[0]] === 'eNPS')) {
        this.openNPSModal(row);
        return;
      }
    },
    
    async openWHO5Modal() {
      this.loadingWHO5 = true;
      this.showWHO5Modal = true;
      this.who5Segments = createDefaultWho5Segments();
      this.who5QuarterName = this.quarterSelected.name || '';
      
      // Always fetch data, whether a specific team is selected or "all teams"
      const team = this.selectTeam !== "all" ? this.selectTeam : "";
      await this.getWHO5Data(team);
    },
    
    async getWHO5Data(team = "") {
      try {
        const db = firebase.firestore();
        const responses = {};
        const questionIds = this.who5Segments.flatMap(segment =>
          segment.questions.map(q => q.id)
        );

        // Get the current date in YYYY-MM-DD format
        const currentDate = new Date().toISOString().split('T')[0];
        
        let quarter;
        let quarterName = this.quarterSelected.name || '';
        
        if (this.quarterSelected.type === "recent") {
          // For "Most Recent Scores" use current quarter
          const currentYear = format(new Date(), 'YYYY');
          const currentQuarter = getQuarter(new Date());
          quarter = Number(`${currentYear}${currentQuarter}`);
          
          console.log(`WHO-5: Trying current quarter ${quarter}`);
          
          // Try to fetch data for current quarter
          let hasData = false;
          // Check if any of the WHO-5 questions have data
          for (const questionId of questionIds) {
            const snapshot = await db.collection('insight_teams_report_card')
              .where('company', '==', this.user.company)
              .where('quest_id', '==', questionId)
              .where('quarter', '==', quarter)
              .limit(1)
              .get();
            
            if (!snapshot.empty) {
              hasData = true;
              break;
            }
          }
          
          // If no data in current quarter, try previous quarter
          if (!hasData) {
            const prevQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
            const prevYear = currentQuarter === 1 ? Number(currentYear) - 1 : Number(currentYear);
            quarter = Number(`${prevYear}${prevQuarter}`);
            
            console.log(`WHO-5: No data in current quarter, trying previous quarter ${quarter}`);
            
            // Check if previous quarter has data
            for (const questionId of questionIds) {
              const snapshot = await db.collection('insight_teams_report_card')
                .where('company', '==', this.user.company)
                .where('quest_id', '==', questionId)
                .where('quarter', '==', quarter)
                .limit(1)
                .get();
              
              if (!snapshot.empty) {
                hasData = true;
                break;
              }
            }
            
            if (!hasData) {
              console.log(`WHO-5: No data found in previous quarter either`);
              return;
            }
            
            // Update quarter name to show we're using previous quarter
            quarterName = `Q${prevQuarter} ${prevYear}`;
          }
        } else {
          // For specific quarters or comparison, use the selected quarter ID
          quarter = Number(this.quarterSelected.id);
        }
        
        // Fetch data for each WHO-5 question
        const promises = questionIds.map(async (questionId) => {
          try {
            const effectiveQuarter = quarter;

            if (team) {
              // For specific team, check both direct team and parent_team
              const teamPromises = [
                db.collection('insight_teams_report_card')
                  .where('company', '==', this.user.company)
                  .where('quest_id', '==', questionId)
                  .where('team', '==', team)
                  .where('quarter', '==', effectiveQuarter)
                  .get(),
                db.collection('insight_teams_report_card')
                  .where('company', '==', this.user.company)
                  .where('quest_id', '==', questionId)
                  .where('parent_team', '==', team)
                  .where('quarter', '==', effectiveQuarter)
                  .get()
              ];
              
              const [directTeamSnapshot, parentTeamSnapshot] = await Promise.all(teamPromises);
              
              let teamData = null;
              
              if (!directTeamSnapshot.empty) {
                directTeamSnapshot.forEach(doc => {
                  teamData = doc.data();
                });
              }
              
              if (!parentTeamSnapshot.empty) {
                parentTeamSnapshot.forEach(doc => {
                  if (!teamData) teamData = doc.data();
                });
              }
              
              if (teamData) {
                const totalResponses = teamData.answer ? 
                  Object.values(teamData.answer).reduce((sum, count) => sum + Number(count), 0) : 0;
                
                if (totalResponses > 0) {
                  const responseBreakdown = {
                    "All of the time": Number(teamData.answer[0] || 0),
                    "Most of the time": Number(teamData.answer[1] || 0),
                    "More than half of the time": Number(teamData.answer[2] || 0),
                    "Less than half of the time": Number(teamData.answer[3] || 0),
                    "Some of the time": Number(teamData.answer[4] || 0),
                    "At no time": Number(teamData.answer[5] || 0)
                  };
                  
                  // Calculate weighted score (WHO-5 specific scoring)
                  const weightedScore = (
                    (responseBreakdown["All of the time"] * 100) +
                    (responseBreakdown["Most of the time"] * 80) +
                    (responseBreakdown["More than half of the time"] * 60) +
                    (responseBreakdown["Less than half of the time"] * 40) +
                    (responseBreakdown["Some of the time"] * 20) +
                    (responseBreakdown["At no time"] * 0)
                  ) / totalResponses;
                  
                  responses[questionId] = {
                    score: Math.round(weightedScore),
                    responses: responseBreakdown,
                    date: teamData.date || currentDate,
                    totalResponses: totalResponses
                  };
                }
              }
            } else {
              // For "all teams", aggregate data across all teams
              const allTeamsSnapshot = await db.collection('insight_teams_report_card')
                .where('company', '==', this.user.company)
                .where('quest_id', '==', questionId)
                .where('quarter', '==', effectiveQuarter)
                .get();
              
              if (!allTeamsSnapshot.empty) {
                const aggregated = {
                  all_time: 0,
                  most_time: 0,
                  more_half: 0,
                  less_half: 0,
                  some_time: 0,
                  no_time: 0,
                  totalResponses: 0
                };
                
                // Build team hierarchy and collect data
                const teamHierarchy = new Map();
                const teamData = new Map();
                
                allTeamsSnapshot.forEach(doc => {
                  const data = doc.data();
                  const teamId = data.team;
                  const parentTeamId = data.parent_team;
                  
                  if (teamId) {
                    teamHierarchy.set(teamId, parentTeamId || null);
                    teamData.set(teamId, data);
                  }
                });
                
                // Find and process top-level teams
                const topLevelTeams = Array.from(teamHierarchy.keys()).filter(team => {
                  const parent = teamHierarchy.get(team);
                  return !parent || !teamHierarchy.has(parent);
                });
                
                topLevelTeams.forEach(teamId => {
                  const data = teamData.get(teamId);
                  if (data && data.answer) {
                    aggregated.all_time += Number(data.answer[0] || 0);
                    aggregated.most_time += Number(data.answer[1] || 0);
                    aggregated.more_half += Number(data.answer[2] || 0);
                    aggregated.less_half += Number(data.answer[3] || 0);
                    aggregated.some_time += Number(data.answer[4] || 0);
                    aggregated.no_time += Number(data.answer[5] || 0);
                  }
                });
                
                const totalResponses = 
                  aggregated.all_time +
                  aggregated.most_time +
                  aggregated.more_half +
                  aggregated.less_half +
                  aggregated.some_time +
                  aggregated.no_time;
                
                if (totalResponses > 0) {
                  const responseBreakdown = {
                    "All of the time": aggregated.all_time,
                    "Most of the time": aggregated.most_time,
                    "More than half of the time": aggregated.more_half,
                    "Less than half of the time": aggregated.less_half,
                    "Some of the time": aggregated.some_time,
                    "At no time": aggregated.no_time
                  };
                  
                  // Calculate weighted score
                  const weightedScore = (
                    (aggregated.all_time * 100) +
                    (aggregated.most_time * 80) +
                    (aggregated.more_half * 60) +
                    (aggregated.less_half * 40) +
                    (aggregated.some_time * 20) +
                    (aggregated.no_time * 0)
                  ) / totalResponses;
                  
                  responses[questionId] = {
                    score: Math.round(weightedScore),
                    responses: responseBreakdown,
                    date: currentDate,
                    totalResponses: totalResponses
                  };
                }
              }
            }
          } catch (error) {
            console.error(`Error fetching WHO-5 data for question ${questionId}:`, error);
          }
        });

        await Promise.all(promises);
        this.who5QuarterName = quarterName;

        // If no responses were found, keep the default data
        if (Object.keys(responses).length === 0) {
          return;
        }

        // Update the segments with the fetched data
        this.who5Segments = this.who5Segments.map(segment => {
          const updatedQuestions = segment.questions.map(question => {
            // If we have response data for this question, update it
            if (responses[question.id]) {
              return {
                ...question,
                score: responses[question.id].score,
                responses: responses[question.id].responses,
                totalResponses: responses[question.id].totalResponses
              };
            }
            
            return question;
          });
          
          return {
            ...segment,
            questions: updatedQuestions
          };
        });
      } catch (error) {
        console.error('Error fetching WHO-5 data:', error);
      } finally {
        this.loadingWHO5 = false;
      }
    },
    
    getResponseClassWHO5(option) {
      // WHO-5 specific response classes
      switch (option) {
        case "All of the time":
          return "bar-who5-all-time";
        case "Most of the time":
          return "bar-who5-most-time";
        case "More than half of the time":
          return "bar-who5-more-half";
        case "Less than half of the time":
          return "bar-who5-less-half";
        case "Some of the time":
          return "bar-who5-some-time";
        case "At no time":
          return "bar-who5-no-time";
        default:
          return "";
      }
    },
    cancelCompare() {
      this.dialogFormVisible = false;
      this.form.before = "";
      this.form.after = "";
      this.quarterOptionModalAfter = [];
    },
    compareQuarter() {
      if (
        !this.form.before.replace(/ /g, "") ||
        !this.form.after.replace(/ /g, "")
      ) {
        this.$message({
          showClose: true,
          message: "Please select quarter",
          type: "error",
        });
        return false;
      }
      let yearbf = this.form.before.substr(0, 4);
      let runQbf = this.form.before.substr(4, 1);
      let yearaf = this.form.after.substr(0, 4);
      let runQaf = this.form.after.substr(4, 1);
      this.$store.commit("report/setquarterCompare", {
        before: this.form.before,
        after: this.form.after,
      });
      this.$store.commit("report/setquarterSelected", {
        id: "compare",
        name: "Q" + runQbf + " " + yearbf + " - " + "Q" + runQaf + " " + yearaf,
        title:
          "Q" + runQbf + " " + yearbf + " vs " + "Q" + runQaf + " " + yearaf,
        type: "compare",
      });
      this.loadReportTable(this.selectTeam);
      this.cancelCompare();
    },
    handleQuarterBefore(key) {
      let quarterAfter = [];
      for (var i = 0; i < this.quarterOptionModal.length; i++) {
        if (this.quarterOptionModal[i].id > key) {
          quarterAfter.push(this.quarterOptionModal[i]);
        }
      }
      this.quarterOptionModalAfter = quarterAfter;
    },
    handleTeams(key) {
      this.selectTeam = key;
      this.loadReportTable(key);
    },
    headerClick(column, event) {
      if (column.index > 1) {
        const team = this.datatable[0][column.index];
        this.selectTeam = team;
        this.loadReportTable(team);
      }
      // this.$store.dispatch('report/expandData', {index: column.index, key: this.datatable[0][column.index]})
    },
    getTeamName(keyId) {
      if (keyId != "Overall" && this.teamkeys[keyId]) {
        return this.teamkeys[keyId].name;
      } else if (keyId != "Overall" && this.cohortkeys[keyId]) {
        return this.cohortkeys[keyId].name;
      } else {
        return keyId;
      }
    },
    tableHeaderStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex > 1) {
        return "cursor: pointer;";
        // if(this.teamsetup[column.label] && this.teamsetup[column.label]['status'] && (this.teamsetup[column.label]['status'] == 'collapse' || this.teamsetup[column.label]['status'] == 'expand')){
        //     return 'cursor: pointer;'
        // }
      }
    },
    detectBackgroundColorChart(row, value) {
      let type = this.questionType[row];
      let breakPoint = [0, 25, 50, 70, 90];
      switch (type) {
        case "Scale":
          breakPoint = [0, 2.5, 5, 7, 9];
          break;
        case "NPS":
          breakPoint = [-100, -30, 0, 30, 70];
          break;
        case "eNPS":
          breakPoint = [-100, -30, 0, 30, 70];
          break;
        case "Multiple Choice":
          breakPoint = [0, 25, 50, 70, 90];
          break;
        case "WHO-5":
          breakPoint = [0, 39, 59, 80, 90];
          break;
        case "eRes":
          breakPoint = [0, 39, 59, 80, 90];
          break;
        case "Culture":
          breakPoint = [0, 39, 59, 80, 90];
          break;
        case "DEBI":
          breakPoint = [0, 19, 39, 70, 85];
          break;
        case "Index":
          breakPoint = [0, 59, 69, 80, 90];
          break;
        case "Variance":
          breakPoint = [0, 59, 69, 80, 90];
          break;
      }
      if (value == "-" || value == -999) {
        return "#F2F2F2";
      } else if (value >= breakPoint[0] && value <= breakPoint[1]) {
        return "#F7CFD0";
      } else if (value > breakPoint[1] && value <= breakPoint[2]) {
        return "#FFEAEA";
      } else if (value > breakPoint[2] && value < breakPoint[3]) {
        return "#FFFBF2";
      } else if (value >= breakPoint[3] && value < breakPoint[4]) {
        return "#D9FDD8";
      } else if (value >= breakPoint[4]) {
        return "#ACFFAC";
      } else if (type == undefined && value == undefined) {
        return "#fff";
      }
    },
    detectBackgroundColor(row, value, columnIndex) {
      let type = this.questionType[row];
      let breakPoint = [0, 25, 50, 70, 90];
      switch (type) {
        case "Scale":
          breakPoint = [0, 2.5, 5, 7, 9];
          break;
        case "NPS":
          breakPoint = [-100, -30, 0, 30, 70];
          break;
        case "eNPS":
          breakPoint = [-100, -30, 0, 30, 70];
          break;
        case "Multiple Choice":
          breakPoint = [0, 25, 50, 70, 90];
          break;
        case "WHO-5":
          breakPoint = [0, 39, 59, 80, 90];
          break;
        case "eRes":
          breakPoint = [0, 39, 59, 80, 90];
          break;
        case "Culture":
          breakPoint = [0, 39, 59, 80, 90];
          break;
        case "DEBI":
          breakPoint = [0, 19, 39, 70, 85];
          break;
        case "Index":
          breakPoint = [0, 59, 69, 80, 90];
          break;
        case "Variance":
          breakPoint = [0, 59, 69, 80, 90];
          break;
      }
      if (value == "-" || value == -999) {
        return "background-color: #F2F2F2;";
      } else if (value >= breakPoint[0] && value <= breakPoint[1]) {
        return "background-color: #F7CFD0;";
      } else if (value > breakPoint[1] && value <= breakPoint[2]) {
        return "background-color: #FFEAEA;";
      } else if (value > breakPoint[2] && value < breakPoint[3]) {
        return "background-color: #FFFBF2;";
      } else if (value >= breakPoint[3] && value < breakPoint[4]) {
        return "background-color: #D9FDD8;";
      } else if (value >= breakPoint[4]) {
        return "background-color: #ACFFAC;";
      } else if (type == undefined && value == undefined) {
        return `background-color: #fff; ${columnIndex !== 1
            ? "border-left: 0px solid transparent !important;"
            : ""
          }`;
      }
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // Base style
      let style = "";

      // Add background color based on value
      if (rowIndex > 0 && columnIndex > 0) {
        if (this.quarterSelected.type == "compare") {
          if (row[columnIndex] == "-" || row[columnIndex] == -999) {
            style = "background-color: #F2F2F2;";
          } else if (row[columnIndex] == 0) {
            style = "background-color: #FFFBF2;";
          } else if (row[columnIndex] > 0) {
            style = "background-color: #ACFFAC;";
          } else if (row[columnIndex] < 0) {
            style = "background-color: #F7CFD0;";
          }
        } else {
          style = this.detectBackgroundColor(
            row[0],
            row[columnIndex],
            columnIndex
          );
        }
      }

      // Add cursor style - only use pointer for NPS, eNPS, WHO-5, and Index types in TEAMS view
      if (rowIndex > 0 && columnIndex > 0 && row[0] && this.showGroup === "teams" &&
          (this.questionType[row[0]] === 'NPS' || 
           this.questionType[row[0]] === 'eNPS' || 
           this.questionType[row[0]] === 'WHO-5' || 
           this.questionType[row[0]] === 'Index')) {
        style += " cursor: pointer;";
      }

      return style;
    },
    rowStyle({ row, rowIndex }) {
      // if(rowIndex > 1){
      //     return "height: 50px;"
      // }
      return "height: 51px;";
    },
    sortBy(type) {
      if (type == "lowest") {
        document.getElementById("sortby_reportcard").innerHTML =
          "Lowest Success Score";
      } else if (type == "highest") {
        document.getElementById("sortby_reportcard").innerHTML =
          "Highest Success Score";
      }
      this.$store.dispatch("report/sortBy", type);
    },
    renderOptionQuarter(creatElement, { column, $index }) {
      let components = [];
      const opts = Array.isArray(this.quarterOption) ? this.quarterOption : [];
      for (var i = 0; i < opts.length; i++) {
        components.push(
          <el-dropdown-item command={opts[i]}>
            {opts[i]["name"] || ""}
          </el-dropdown-item>
        );
      }
      components.push(
        <el-dropdown-item command="compare">
          Quarter-by-quarter Comparison
        </el-dropdown-item>
      );
      const quarterName = this.quarterSelected && this.quarterSelected.name ? this.quarterSelected.name : "Select Quarter";
      return (
        <div
          class="flex-center rotate"
          style="margin-top: 50px; padding-left: 0px; width: 300px;"
        >
          <el-dropdown
            style="padding-left: 0px;"
            onCommand={this.handleCommand}
          >
            <span
              class="el-dropdown-link fw-700"
              style="color: #000000; font-size: 18px;"
            >
              {quarterName}
              <i
                style="margin-left: 24px;"
                class="el-icon-arrow-down el-icon--right"
              ></i>
            </span>

            <el-dropdown-menu slot="dropdown">{components}</el-dropdown-menu>
          </el-dropdown>
          <svg
            onClick={this.onExportClick}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export ml-10"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11z" />
          </svg>
        </div>
      );
    },
    async onExportClick() {
      if (this.showGroup == "teams") {
        this.$store.dispatch("report/getDataExport");
      } else {
        this.$store.dispatch("report/getDataExportCohort");
      }
    },
    handleCommand(command) {
      if (command == "compare") {
        this.title_dialog = "Quarter-by-quarter Comparison";
        this.mode = "";
        // this.cancelAdd()
        this.dialogFormVisible = true;
      } else {
        this.$store.commit("report/setquarterSelected", {
          id: command["id"],
          name: command["name"],
          title: command["name"],
          type: command["type"],
        });
        this.loadReportTable(this.selectTeam);
      }
    },
    renderPhaseHeader(h, { column }) {
      if (column.label == "*") {
        return;
      }
      let className = "labelTable horizontalText";
      let dataLength = this.datatable[0].length;
      if (this.datatable) {
        if (dataLength > 7) {
          className = "labelTable rotate rotate-7";
        } else if (dataLength > 6) {
          className = "labelTable rotate rotate-6";
        } else if (dataLength > 5) {
          className = "labelTable rotate rotate-5";
        } else if (dataLength > 4) {
          className = "labelTable rotate rotate-4";
        } else if (dataLength > 3) {
          className = "labelTable rotate rotate-3";
        }
      } else {
        return;
      }
      let text = column.label;
      if (column.label != "Overall" && this.teamkeys[column.label]) {
        text = this.teamkeys[column.label].name;
      } else if (column.label != "Overall" && this.cohortkeys[column.label]) {
        text = this.cohortkeys[column.label].name;
      }
      let blurClass = "";
      if (this.blurMode) {
        blurClass = "blurelement";
      }
      return h(
        "div",
        {
          class: [className, blurClass]
        },
        [
          h(
            "div",
            {
              class: "ellipsis left",
              style: "overflow: hidden; width: 140px;",
            },
            text
          ),
        ]
      );
    },
    renderCellData(row, index) {
      let text = "";
      if (
        (this.quarterSelected.type == "compare" ||
          this.questionType[row[0]] == "NPS" ||
          this.questionType[row[0]] == "eNPS") &&
        row[index] > 0
      ) {
        text += "+";
      }
      if (row[index] == "-" || row[index] == -999) {
        text += "-";
      } else {
        text +=
          row[index] +
          (this.questionType[row[0]] == "Scale" ||
            this.questionType[row[0]] == "NPS" ||
            this.questionType[row[0]] == "eNPS" ||
            this.questionType[row[0]] == "WHO-5" ||
            this.questionType[row[0]] == "eRes" ||
            this.questionType[row[0]] == "Culture" ||
            this.questionType[row[0]] == "DEBI"
            ? ""
            : "%");
      }
      return text;
    },
    renderTotalData(row) {
      let text = "";
      if (
        (this.quarterSelected.type == "compare" ||
          this.questionType[row[0]] == "NPS" ||
          this.questionType[row[0]] == "eNPS") &&
        row[1] > 0
      ) {
        text += "+";
      }
      text += row[1];
      if (
        this.questionType[row[0]] != "Scale" &&
        this.questionType[row[0]] !== "NPS" &&
        this.questionType[row[0]] !== "eNPS" &&
        this.questionType[row[0]] !== "WHO-5" &&
        this.questionType[row[0]] !== "eRes" &&
        this.questionType[row[0]] !== "Culture" &&
        this.questionType[row[0]] !== "DEBI"
      ) {
        text += "%";
      }
      return this.showGroup == "cohorts" ? "" : text;
    },
    getImgUrl(pic) {
      var images = require.context(
        "../../assets/images/reportcard/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    tagColor(value) {
      if (this.quarterSelected.type == "compare" && this.showGroup == "teams") {
        if (value < 0) {
          return "red";
        } else if (value > 0) {
          return "green";
        } else if (value == 0) {
          return "yellow";
        }
      } else {
        if (value >= 30 && value < 101) {
          return "green";
        } else if (value >= 1 && value < 30) {
          return "yellow";
        } else {
          return "red";
        }
      }
      return "green";
    },
    tagColorDEBI(value) {
      if (this.quarterSelected.type == "compare" && this.showGroup == "teams") {
        if (value < 0) {
          return "red";
        } else if (value > 0) {
          return "green";
        } else if (value == 0) {
          return "yellow";
        }
      } else {
        if (value >= 70) {
          return "green";
        } else if (value >= 40 && value < 70) {
          return "yellow";
        } else {
          return "red";
        }
      }
      return "green";
    },
    tagColorStrategicAlignment(value) {
      if (this.quarterSelected.type == "compare" && this.showGroup == "teams") {
        if (value < 0) {
          return "red";
        } else if (value > 0) {
          return "green";
        } else if (value == 0) {
          return "yellow";
        }
      } else {
        if (value >= 80) {
          return "green";
        } else if (value >= 70 && value < 80) {
          return "yellow";
        } else {
          return "red";
        }
      }
      return "green";
    },
    tagColorIndex(value) {
      if (this.quarterSelected.type == "compare" && this.showGroup == "teams") {
        if (value < 0) {
          return "red";
        } else if (value > 0) {
          return "green";
        } else if (value == 0) {
          return "yellow";
        }
      } else {
        if (value >= 80 && value < 101) {
          return "green";
        } else if (value >= 60 && value < 80) {
          return "yellow";
        } else {
          return "red";
        }
      }
      return "green";
    },
    showingHistoryChart(scope) {
      this.widthOfPopup = `width: 325px;`;
      if (scope && this.questionType[scope.row[0]]) {
        if (
          this.questionSelected &&
          this.questionSelected == scope.row[0] &&
          this.idSelected &&
          this.idSelected == this.selectTeam
        ) {
          return;
        } else {
          if (this.RanderTooltipBarChart) {
            this.RanderTooltipBarChart.destroy();
          }
          this.questionSelected = scope.row[0];
          this.idSelected = this.selectTeam;
          this.hoverData.loading = true;
          this.hoverData.hover = true;
          this.randerBarChartMission(scope);
        }
      } else {
        setTimeout(() => {
          this.hoverData.loading = false;
        }, 2000);
        this.hoverData.hover = false;
      }
    },
    getTypeOfData(row) {
      let text = "nothing";
      if (
        (this.quarterSelected.type == "compare" ||
          this.questionType[row[0]] == "NPS" ||
          this.questionType[row[0]] == "eNPS") &&
        row[1] > 0
      ) {
        text = "value";
      }
      if (
        this.questionType[row[0]] != "Scale" &&
        this.questionType[row[0]] !== "NPS" &&
        this.questionType[row[0]] !== "eNPS" &&
        this.questionType[row[0]] !== "WHO-5" &&
        this.questionType[row[0]] !== "eRes" &&
        this.questionType[row[0]] !== "Culture" &&
        this.questionType[row[0]] !== "DEBI"
      ) {
        text = "percentage";
      }
      return text;
    },
    randerBarChartMission(scope) {
      this.rowSelected = scope.row;
      if (this.showGroup == "teams") {
        this.$store.dispatch("report/getScoreHistoryChart", scope);
      } else {
        this.$store.dispatch("report/getScoreHistoryChartCohort", {
          data: scope,
          cohortId: this.selectTeam,
        });
      }
    },
    getColorChange() {
      let chartMaxChange = this.chartMaxChange;
      let txt = "";
      if (chartMaxChange > 0) {
        txt = "66BB6A";
      } else if (chartMaxChange < 0) {
        txt = "F44336";
      } else {
        txt = "747474";
      }
      return txt;
    },
    shouldShowAlignmentFlag(questionId) {
      const varianceRow = this.datatable.find(row =>
        row[0] && this.questionType[row[0]] === 'Variance'
      );

      if (varianceRow && varianceRow[1] < this.varianceThreshold) {
        return true;
      }

      return false;
    },
    async openStrategicAlignmentModal() {
      this.loadingStrategicAlignment = true;
      this.showStrategicAlignmentModal = true;
      
      // Always fetch data, whether a specific team is selected or "all teams"
      const team = this.selectTeam !== "all" ? this.selectTeam : "";
      await this.getStrategicAlignmentData(team);
    },
    
    async getStrategicAlignmentData(team = "") {
      try {
        const db = firebase.firestore();
        const responses = {};
        const questionIds = this.strategicAlignmentSegments.flatMap(segment =>
          segment.questions.map(q => q.id)
        );

        // Get the current date in YYYY-MM-DD format
        const currentDate = new Date().toISOString().split('T')[0];
        
        let quarter;
        let quarterName = this.quarterSelected.name;
        let quarterType = this.quarterSelected.type;
        
        if (this.quarterSelected.type === "recent") {
          // For "Most Recent Scores", each question gets its most recent available data
          console.log(`Strategic Alignment: Finding most recent data for each question individually`);
          this.strategicAlignmentQuarterName = 'Most Recent Data';
          quarter = null; // Not used in Most Recent mode
        } else {
          // For specific quarters, only use that exact quarter - no fallback
          quarter = Number(this.quarterSelected.id);
          this.strategicAlignmentQuarterName = ''; // Use original quarter name
          console.log(`Strategic Alignment: Using specific quarter ${quarter}, no fallback`);
        }
        
        // Fetch data for each strategic alignment question
        const promises = questionIds.map(async (questionId) => {
          try {
            let effectiveQuarter = quarter;
            
            // For "Most Recent" mode, find the most recent quarter with data for this specific question
            if (this.quarterSelected.type === "recent") {
              const currentYear = format(new Date(), 'YYYY');
              const currentQuarter = getQuarter(new Date());
              let testQuarter = Number(`${currentYear}${currentQuarter}`);
              let testYear = Number(currentYear);
              let testQ = currentQuarter;
              let foundQuestionData = false;
              
              // Try up to 8 quarters back to find data for this specific question
              for (let attempts = 0; attempts < 8 && !foundQuestionData; attempts++) {
                const testSnapshot = await db.collection('insight_teams_report_card')
                  .where('company', '==', this.user.company)
                  .where('quest_id', '==', questionId)
                  .where('quarter', '==', testQuarter)
                  .limit(1)
                  .get();
                
                if (!testSnapshot.empty) {
                  effectiveQuarter = testQuarter;
                  foundQuestionData = true;
                  // console.log(`Strategic Alignment: Found data for question ${questionId} in quarter ${effectiveQuarter}`);
                } else {
                  // Move to previous quarter
                  testQ = testQ === 1 ? 4 : testQ - 1;
                  testYear = testQ === 4 ? testYear - 1 : testYear;
                  testQuarter = Number(`${testYear}${testQ}`);
                }
              }
              
              if (!foundQuestionData) {
                // console.log(`Strategic Alignment: No data found for question ${questionId} in any recent quarters`);
                return; // Skip this question
              }
            }
            
            // Add team filter if a specific team is selected
            if (team) {
              // For specific team, we need to check both direct team and parent_team
              const teamPromises = [
                db.collection('insight_teams_report_card')
                  .where('company', '==', this.user.company)
                  .where('quest_id', '==', questionId)
                  .where('team', '==', team)
                  .where('quarter', '==', effectiveQuarter)
                  .get(),
                db.collection('insight_teams_report_card')
                  .where('company', '==', this.user.company)
                  .where('quest_id', '==', questionId)
                  .where('parent_team', '==', team)
                  .where('quarter', '==', effectiveQuarter)
                  .get()
              ];
              
              const [directTeamSnapshot, parentTeamSnapshot] = await Promise.all(teamPromises);
              
              // Process the results
              let teamData = null;
              
              if (!directTeamSnapshot.empty) {
                directTeamSnapshot.forEach(doc => {
                  teamData = doc.data();
                });
              }
              
              if (!parentTeamSnapshot.empty) {
                parentTeamSnapshot.forEach(doc => {
                  if (!teamData) teamData = doc.data();
                });
              }
              
              if (teamData) {
                // Calculate total responses
                const totalResponses = teamData.answer ? 
                  Object.values(teamData.answer).reduce((sum, count) => sum + Number(count), 0) : 0;
                
                if (totalResponses > 0) {
                  // Calculate the response breakdown
                  const responseBreakdown = {
                    "Strongly Agree": 0,
                    "Agree": 0,
                    "Neutral": 0,
                    "Disagree": 0,
                    "Strongly Disagree": 0
                  };
                  
                  if (teamData.answer) {
                    // Map numeric answers to response categories
                    if (teamData.answer[0]) responseBreakdown["Strongly Agree"] = Number(teamData.answer[0]);
                    if (teamData.answer[1]) responseBreakdown["Agree"] = Number(teamData.answer[1]);
                    if (teamData.answer[2]) responseBreakdown["Neutral"] = Number(teamData.answer[2]);
                    if (teamData.answer[3]) responseBreakdown["Disagree"] = Number(teamData.answer[3]);
                    if (teamData.answer[4]) responseBreakdown["Strongly Disagree"] = Number(teamData.answer[4]);
                    
                    // Calculate weighted score
                    const weightedScore = (
                      (Number(teamData.answer[0] || 0) * 1.0) +  // Strongly Agree
                      (Number(teamData.answer[1] || 0) * 0.75) + // Agree
                      (Number(teamData.answer[2] || 0) * 0.5) +  // Neutral
                      (Number(teamData.answer[3] || 0) * 0.25) + // Disagree
                      (Number(teamData.answer[4] || 0) * 0)      // Strongly Disagree
                    ) / totalResponses * 100;
                    
                    responses[questionId] = {
                      score: Math.round(weightedScore),
                      responses: responseBreakdown,
                      date: teamData.date || currentDate,
                      totalResponses: totalResponses
                    };
                  }
                }
              }
            } else {
              // For "all teams", aggregate data across teams
              const allTeamsSnapshot = await db.collection('insight_teams_report_card')
                .where('company', '==', this.user.company)
                .where('quest_id', '==', questionId)
                .where('quarter', '==', effectiveQuarter)
                .get();
                
              if (!allTeamsSnapshot.empty) {
                const aggregated = {
                  strongly_agree: 0,
                  agree: 0,
                  neutral: 0,
                  disagree: 0,
                  strongly_disagree: 0,
                  totalResponses: 0
                };
                
                // Build team hierarchy and collect data
                const teamHierarchy = new Map();
                const teamData = new Map();
                
                allTeamsSnapshot.forEach(doc => {
                  const data = doc.data();
                  const teamId = data.team;
                  const parentTeamId = data.parent_team;
                  
                  if (teamId) {
                    teamHierarchy.set(teamId, parentTeamId || null);
                    teamData.set(teamId, data);
                  }
                });
                
                // Find and process top-level teams
                const topLevelTeams = Array.from(teamHierarchy.keys()).filter(team => {
                  const parent = teamHierarchy.get(team);
                  return !parent || !teamHierarchy.has(parent);
                });
                
                topLevelTeams.forEach(teamId => {
                  const data = teamData.get(teamId);
                  if (data && data.answer) {
                    aggregated.strongly_agree += Number(data.answer[0] || 0);
                    aggregated.agree += Number(data.answer[1] || 0);
                    aggregated.neutral += Number(data.answer[2] || 0);
                    aggregated.disagree += Number(data.answer[3] || 0);
                    aggregated.strongly_disagree += Number(data.answer[4] || 0);
                  }
                });
                
                const totalResponses = 
                  aggregated.strongly_agree +
                  aggregated.agree +
                  aggregated.neutral +
                  aggregated.disagree +
                  aggregated.strongly_disagree;
                
                if (totalResponses > 0) {
                  // Calculate weighted score
                  const weightedScore = (
                    (aggregated.strongly_agree * 1.0) +
                    (aggregated.agree * 0.75) +
                    (aggregated.neutral * 0.5) +
                    (aggregated.disagree * 0.25) +
                    (aggregated.strongly_disagree * 0)
                  ) / totalResponses * 100;
                  
                  responses[questionId] = {
                    score: Math.round(weightedScore),
                    responses: {
                      "Strongly Agree": aggregated.strongly_agree,
                      "Agree": aggregated.agree,
                      "Neutral": aggregated.neutral,
                      "Disagree": aggregated.disagree,
                      "Strongly Disagree": aggregated.strongly_disagree
                    },
                    date: currentDate,
                    totalResponses: totalResponses
                  };
                }
              }
            }
          } catch (error) {
            // Error handling is silent in production
          }
        });

        await Promise.all(promises);

        // If we don't have enough data to calculate Strategic Alignment Index, keep default
        if (Object.keys(responses).length === 0) {
          this.loadingStrategicAlignment = false;
          return;
        }

        // Update the segments with the fetched data
        this.strategicAlignmentSegments = this.strategicAlignmentSegments.map(segment => {
          const updatedQuestions = segment.questions.map(question => {
            // If we have response data for this question, update it
            if (responses[question.id]) {
              return {
                ...question,
                score: responses[question.id].score,
                responses: responses[question.id].responses,
                totalResponses: responses[question.id].totalResponses
              };
            }
            
            return question;
          });
          
          // Calculate category score (average of all questions in this segment)
          const questionsWithResponses = updatedQuestions.filter(q => responses[q.id]);
          let categoryScore = 0;
          
          if (questionsWithResponses.length > 0) {
            categoryScore = Math.round(
              questionsWithResponses.reduce((sum, q) => sum + q.score, 0) / questionsWithResponses.length
            );
          }
          
          return {
            ...segment,
            questions: updatedQuestions,
            categoryScore: categoryScore
          };
        });

        // Calculate overall alignment index (average of all question scores)
        const allQuestions = this.strategicAlignmentSegments.flatMap(segment => segment.questions);
        const questionsWithScores = allQuestions.filter(q => responses[q.id]);
        
        if (questionsWithScores.length > 0) {
          const totalScore = questionsWithScores.reduce((sum, q) => sum + q.score, 0);
          const alignmentIndex = Math.round(totalScore / questionsWithScores.length);
          // Add overall index if needed for display
          this.strategicAlignmentOverallScore = alignmentIndex; 
        }
        
        this.loadingStrategicAlignment = false;
      } catch (error) {
        this.loadingStrategicAlignment = false;
      }
    },
    async openCultureModal() {
      this.loadingCulture = true;
      this.showCultureModal = true;

      const team = this.selectTeam !== "all" ? this.selectTeam : "";
      await this.getCultureData(team);
    },

    async getCultureData(team = "") {
      try {
        const db = firebase.firestore();

        // Get culture question IDs from store
        // Use custom culture questions if available, otherwise use hardcoded questionSet3
        const questionCultureCustom = this.$store.state.report.questionCultureCustom || [];
        const questionSet3 = this.$store.state.report.questionSet3;
        const isUsingCustomQuestions = questionCultureCustom.length > 0;
        const questionIds = isUsingCustomQuestions
          ? questionCultureCustom
          : Object.values(questionSet3);

        // Get full question data from questionMasterArr (already loaded in store)
        const questionMasterArr = this.$store.state.report.questionMasterArr;

        // Build questions array with text from questionMasterArr
        // For custom questions: use report_card_label (row header)
        // For default questions: use question text (since row headers are all the same generic text)
        const questions = [];
        for (const qId of questionIds) {
          const questionData = questionMasterArr ? questionMasterArr[qId] : null;
          const isScale = questionData && questionData.type === 'Scale';
          let displayText = qId;
          if (questionData) {
            if (isUsingCustomQuestions) {
              displayText = questionData.report_card_label || questionData.question_en || questionData.question || qId;
            } else {
              displayText = questionData.question_en || questionData.question || questionData.report_card_label || qId;
            }
          }

          const responses = isScale
            ? { "Promoter (9-10)": 0, "High (7-8)": 0, "Moderate (4-6)": 0, "Low (1-3)": 0, "Zero (0)": 0 }
            : { "Strongly Agree": 0, "Agree": 0, "Neutral": 0, "Disagree": 0, "Strongly Disagree": 0 };

          questions.push({
            id: qId,
            text: displayText,
            questionType: isScale ? 'Scale' : 'MultipleChoice',
            score: undefined,
            responses: responses,
            totalResponses: 0
          });
        }

        // Determine quarter to use
        let effectiveQuarter;
        if (this.quarterSelected.type === "recent") {
          this.cultureQuarterName = 'Most Recent Data';
          // Find the most recent quarter with any culture data (single query)
          const currentYear = format(new Date(), 'YYYY');
          const currentQuarter = getQuarter(new Date());
          let testQuarter = Number(`${currentYear}${currentQuarter}`);
          let testYear = Number(currentYear);
          let testQ = currentQuarter;

          // Try up to 8 quarters back to find data
          for (let attempts = 0; attempts < 8; attempts++) {
            const testSnapshot = await db.collection('insight_teams_report_card')
              .where('company', '==', this.user.company)
              .where('quest_id', '==', questionIds[0]) // Check first question
              .where('quarter', '==', testQuarter)
              .limit(1)
              .get();

            if (!testSnapshot.empty) {
              effectiveQuarter = testQuarter;
              break;
            }
            testQ = testQ === 1 ? 4 : testQ - 1;
            testYear = testQ === 4 ? testYear - 1 : testYear;
            testQuarter = Number(`${testYear}${testQ}`);
          }

          if (!effectiveQuarter) {
            // No data found, show empty questions
            this.cultureSegments = [{ name: "Culture Index Questions", questions: questions }];
            return;
          }
        } else {
          this.cultureQuarterName = this.quarterSelected.name;
          effectiveQuarter = Number(this.quarterSelected.id);
        }

        const aggregateAnswers = (question, answerObj) => {
          if (!answerObj) return;
          const isScale = question.questionType === 'Scale';

          if (isScale) {
            for (let i = 0; i <= 10; i++) {
              if (answerObj[i]) {
                const count = Number(answerObj[i]);
                question.totalResponses += count;
                if (i >= 9) question.responses["Promoter (9-10)"] += count;
                else if (i >= 7) question.responses["High (7-8)"] += count;
                else if (i >= 4) question.responses["Moderate (4-6)"] += count;
                else if (i >= 1) question.responses["Low (1-3)"] += count;
                else question.responses["Zero (0)"] += count;
              }
            }
          } else {
            for (let i = 0; i <= 4; i++) {
              if (answerObj[i]) {
                const count = Number(answerObj[i]);
                question.totalResponses += count;
                switch(i) {
                  case 0: question.responses["Strongly Agree"] += count; break;
                  case 1: question.responses["Agree"] += count; break;
                  case 2: question.responses["Neutral"] += count; break;
                  case 3: question.responses["Disagree"] += count; break;
                  case 4: question.responses["Strongly Disagree"] += count; break;
                }
              }
            }
          }
        };

        // Fetch all question data in parallel
        const fetchPromises = questions.map(async (question) => {
          if (team) {
            const [directSnapshot, parentSnapshot] = await Promise.all([
              db.collection("insight_teams_report_card")
                .where("company", "==", this.user.company)
                .where("quest_id", "==", question.id)
                .where("team", "==", team)
                .where("quarter", "==", effectiveQuarter)
                .get(),
              db.collection("insight_teams_report_card")
                .where("company", "==", this.user.company)
                .where("quest_id", "==", question.id)
                .where("parent_team", "==", team)
                .where("quarter", "==", effectiveQuarter)
                .get()
            ]);

            [directSnapshot, parentSnapshot].forEach(snapshot => {
              snapshot.forEach(doc => {
                aggregateAnswers(question, doc.data().answer);
              });
            });
          } else {
            const allTeamsSnapshot = await db.collection("insight_teams_report_card")
              .where("company", "==", this.user.company)
              .where("quest_id", "==", question.id)
              .where("quarter", "==", effectiveQuarter)
              .get();

            const teamHierarchy = new Map();
            const teamData = new Map();

            allTeamsSnapshot.forEach(doc => {
              const data = doc.data();
              const teamId = data.team;
              const parentTeamId = data.parent_team;
              if (teamId) {
                teamHierarchy.set(teamId, parentTeamId || null);
                teamData.set(teamId, data);
              }
            });

            const topLevelTeams = Array.from(teamHierarchy.keys()).filter(t => {
              const parent = teamHierarchy.get(t);
              return !parent || !teamHierarchy.has(parent);
            });

            topLevelTeams.forEach(teamId => {
              const data = teamData.get(teamId);
              if (data) {
                aggregateAnswers(question, data.answer);
              }
            });
          }

          // Calculate weighted score (0-100)
          if (question.totalResponses > 0) {
            if (question.questionType === 'Scale') {
              const r = question.responses;
              const weightedSum =
                (r["Promoter (9-10)"] * 9.5) +
                (r["High (7-8)"] * 7.5) +
                (r["Moderate (4-6)"] * 5.0) +
                (r["Low (1-3)"] * 2.0) +
                (r["Zero (0)"] * 0);
              question.score = Math.round((weightedSum / question.totalResponses) * 10);
            } else {
              const r = question.responses;
              const weightedSum =
                (r["Strongly Agree"] * 1.0) +
                (r["Agree"] * 0.75) +
                (r["Neutral"] * 0.5) +
                (r["Disagree"] * 0.25) +
                (r["Strongly Disagree"] * 0);
              question.score = Math.round((weightedSum / question.totalResponses) * 100);
            }
          }
        });

        // Wait for all questions to be fetched in parallel
        await Promise.all(fetchPromises);

        // Update segments
        this.cultureSegments = [{
          name: "Culture Index Questions",
          questions: questions
        }];

      } catch (error) {
        console.error("Error fetching culture data:", error);
      } finally {
        this.loadingCulture = false;
      }
    },
    getScoreColor(score) {
      if (score >= 80) return '#ACFFAC';
      if (score >= 70) return '#FFFBF2';
      return '#F7CFD0';
    },
    getResponseColor(option) {
      // Implement your logic to determine response color based on option
      switch (option) {
        case "Strongly Agree":
          return "bar-results-agree";
        case "Agree":
          return "bar-results-agree";
        case "Neutral":
          return "bar-results-neutral";
        case "Disagree":
          return "bar-results-disagree";
        case "Strongly Disagree":
          return "bar-results-disagree";
        default:
          return "";
      }
    },
    getResponseWidth(value) {
      // Safely convert value to number and handle invalid cases
      const numValue = Number(value);
      if (isNaN(numValue) || numValue < 0) {
        return 0;
      }
      
      // Return the value directly since it should already be a percentage
      return numValue;
    },
    getResponseClass(option) {
      switch (option) {
        case "Strongly Agree":
          return "bar-results-strongly-agree";
        case "Agree":
          return "bar-results-agree";
        case "Neutral":
          return "bar-results-neutral";
        case "Disagree":
          return "bar-results-disagree";
        case "Strongly Disagree":
          return "bar-results-strongly-disagree";
        default:
          return "";
      }
    },
    getResponseClassScale(option) {
      switch (option) {
        case "Promoter (9-10)":
          return "bar-scale-promoter";
        case "High (7-8)":
          return "bar-scale-high";
        case "Moderate (4-6)":
          return "bar-scale-moderate";
        case "Low (1-3)":
          return "bar-scale-low";
        case "Zero (0)":
          return "bar-scale-zero";
        default:
          return "";
      }
    },
    async openNPSModal(row) {
      // Store the current row for future refreshes when quarter changes
      this.lastNPSRow = row;
      
      // Only set loading and show the modal if we're opening it for the first time
      if (!this.showNPSModal) {
        this.loadingNPS = true;
        this.showNPSModal = true;
      } else {
        // If already showing, just indicate loading for refresh
        this.loadingNPS = true;
      }
      
      // Set the metric type (NPS or eNPS)
      this.selectedMetric = this.questionType[row[0]];
      
      // Clear previous data to ensure we're not displaying stale data
      this.npsData = null;
      
      try {
        const db = firebase.firestore();
        let quarter;
        let quarterName = this.quarterSelected.name;
        let quarterType = this.quarterSelected.type;
        
        if (this.quarterSelected.type === "recent") {
          // For "Most Recent Scores" use current quarter
          const currentYear = format(new Date(), 'YYYY');
          const currentQuarter = getQuarter(new Date());
          quarter = Number(currentYear + currentQuarter);
          
          // console.log(`Trying current quarter ${quarter} for ${row[0]}`);
          
          // Try to fetch data for current quarter
          let hasData = await this.checkQuarterHasData(db, row[0], quarter);
          
          // If no data in current quarter, try previous quarter
          if (!hasData) {
            const prevQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
            const prevYear = currentQuarter === 1 ? Number(currentYear) - 1 : Number(currentYear);
            // Fix: Properly format the quarter number to ensure it's a single digit
            quarter = Number(`${prevYear}${prevQuarter}`);
            
            // console.log(`No data in current quarter, trying previous quarter ${quarter}`);
            
            // Check if previous quarter has data
            hasData = await this.checkQuarterHasData(db, row[0], quarter);
            if (!hasData) {
              console.log(`No data found in previous quarter either`);
              this.npsData = {
                total: 0,
                promotors: 0,
                passives: 0,
                detractors: 0,
                percent: {
                  promotors: 0,
                  passives: 0,
                  detractors: 0
                },
                type: this.selectedMetric === 'eNPS' ? 'enps' : 'nps',
                quarter: {
                  id: quarter,
                  name: quarterName,
                  type: quarterType
                },
                allScores: Array(11).fill(0).map((_, score) => ({ score, count: 0 }))
              };
              this.loadingNPS = false;
              return;
            }
            
            // Update quarter name to show we're using previous quarter
            quarterName = `Q${prevQuarter} ${prevYear}`;
          }
        } else {
          // For specific quarters or comparison, use the selected quarter ID
          quarter = Number(this.quarterSelected.id);
        }
        
        // Initialize NPS data structure
        const allScores = Array(11).fill(0); // 0-10 scores
        let totalResponses = 0;
        let querySnapshot;

        if (this.selectTeam !== "all") {
          // Specific team selected - fetch data for just that team
          const team = this.selectTeam;
          
          // console.log(`Fetching data for team ${team}, quarter ${quarter}`);
          
          // Try direct team match first
          querySnapshot = await db.collection('insight_teams_report_card')
            .where('company', '==', this.user.company)
            .where('quest_id', '==', row[0])
            .where('team', '==', team)
            .where('quarter', '==', quarter)
            .get();
          
          // If no direct match, try parent team match
          if (querySnapshot.empty) {
            console.log(`No direct team match, trying parent team match`);
            querySnapshot = await db.collection('insight_teams_report_card')
              .where('company', '==', this.user.company)
              .where('quest_id', '==', row[0])
              .where('parent_team', '==', team)
              .where('quarter', '==', quarter)
              .get();
          }
          
          // Process results for specific team
          if (!querySnapshot.empty) {
            console.log('-- NPS Modal (Specific Team): Processing responses --');
            querySnapshot.forEach(doc => {
              const data = doc.data();
              if (data.answer) {
                let docResponseCount = 0;
                Object.entries(data.answer).forEach(([score, count]) => {
                  allScores[Number(score)] = (allScores[Number(score)] || 0) + Number(count);
                  totalResponses += Number(count);
                  docResponseCount += Number(count);
                });
                // console.log(`  - Doc ID: ${doc.id}, Team: ${data.team || 'N/A'}, Parent: ${data.parent_team || 'N/A'}, Responses: ${docResponseCount}`);
              }
            });
            // console.log(`Processed team data: ${totalResponses} total responses`);
          } else {
            // console.log(`No data found for team ${team} in quarter ${quarter}`);
          }
        } else {
          // "All teams" selected - we need to aggregate across all teams
          // console.log(`Fetching data for all teams, quarter ${quarter}`);
          
          // Get data for all teams in the company for this metric and quarter
          const teamsRef = db.collection('insight_teams_report_card')
            .where('company', '==', this.user.company)
            .where('quest_id', '==', row[0])
            .where('quarter', '==', quarter);
          
          querySnapshot = await teamsRef.get();
          
          // Process ALL teams data - we'll need to deduplicate responses
          const processedTeams = new Set(); // Keep track of teams we've already counted
          
          if (!querySnapshot.empty) {
            console.log('-- NPS Modal (All Teams): Processing responses --'); // Added console log
            querySnapshot.forEach(doc => {
              const data = doc.data();
              const teamId = data.team || '';
              
              // Skip if we've already processed this team (to avoid double counting)
              if (processedTeams.has(teamId)) {
                // console.log(`  - Skipping already processed team: ${teamId}`); // Optional: Log skipped teams
                return;
              }
              
              // **** ADDED CHECK: Only process if teamId exists and is not empty ****
              if (teamId && teamId !== '') { 
                // Only process top-level teams (those without a parent_team)
                // or teams that are direct children of the root
                if (!data.parent_team || data.parent_team === '') {
                  processedTeams.add(teamId);
                  
                  if (data.answer) {
                    let docResponseCount = 0; // Count responses for this specific document
                    Object.entries(data.answer).forEach(([score, count]) => {
                      allScores[Number(score)] = (allScores[Number(score)] || 0) + Number(count);
                      totalResponses += Number(count);
                      docResponseCount += Number(count);
                    });
                    //  console.log(`  - Including Doc ID: ${doc.id}, Team: ${teamId}, Parent: ${data.parent_team || 'N/A'}, Responses: ${docResponseCount}`); // Log count for this doc
                  } else {
                    //  console.log(`  - Including Doc ID: ${doc.id}, Team: ${teamId}, Parent: ${data.parent_team || 'N/A'}, Responses: 0 (No answer data)`);
                  }
                } else {
                  // console.log(`  - Skipping non-top-level team: ${teamId}, Parent: ${data.parent_team}`); // Optional log
                }
              } else {
                //  console.log(`  - Skipping Doc ID: ${doc.id} due to missing/empty teamId.`); // Log skipped doc
              }
            });
            // console.log(`Processed all teams data: ${totalResponses} total responses`);
          } else {
            // console.log(`No data found for any teams in quarter ${quarter}`);
          }
        }

        // If we have no responses, show empty state
        if (totalResponses === 0) {
          console.log('No responses found, showing empty state');
          this.npsData = {
            total: 0,
            promotors: 0,
            passives: 0,
            detractors: 0,
            percent: {
              promotors: 0,
              passives: 0,
              detractors: 0
            },
            type: this.selectedMetric === 'eNPS' ? 'enps' : 'nps',
            quarter: {
              id: quarter,
              name: quarterName,
              type: quarterType
            },
            allScores: Array(11).fill(0).map((_, score) => ({ score, count: 0 }))
          };
          this.loadingNPS = false;
          return;
        }

        // Calculate promoters, passives, detractors
        const promoters = allScores[9] + allScores[10];
        const passives = allScores[7] + allScores[8];
        const detractors = allScores.slice(0, 7).reduce((a, b) => a + b, 0);
        
        // Calculate raw percentages (unrounded)
        const promotersPercentRaw = totalResponses > 0 ? (promoters / totalResponses) * 100 : 0;
        const passivesPercentRaw = totalResponses > 0 ? (passives / totalResponses) * 100 : 0;
        const detractorsPercentRaw = totalResponses > 0 ? (detractors / totalResponses) * 100 : 0;
        
        // Calculate NPS score using unrounded percentages
        const npsScore = Math.round(promotersPercentRaw - detractorsPercentRaw);
        
        // Round percentages for display
        const promotersPercent = Math.round(promotersPercentRaw);
        const passivesPercent = Math.round(passivesPercentRaw);
        const detractorsPercent = Math.round(detractorsPercentRaw);

        console.log(`Final calculations:
          Total Responses: ${totalResponses}
          NPS Score: ${npsScore}
          Promoters: ${promoters} (${promotersPercent}%)
          Passives: ${passives} (${passivesPercent}%)
          Detractors: ${detractors} (${detractorsPercent}%)`);

        this.npsData = {
          total: npsScore,
          promotors: promoters,
          passives: passives,
          detractors: detractors,
          percent: {
            promotors: promotersPercent,
            passives: passivesPercent,
            detractors: detractorsPercent
          },
          type: this.selectedMetric === 'eNPS' ? 'enps' : 'nps',
          quarter: {
            id: quarter,
            name: quarterName,
            type: quarterType
          },
          allScores: allScores.map((count, score) => ({ score, count }))
        };
        
        this.loadingNPS = false;
      } catch (error) {
        console.error('Error fetching NPS data:', error);
        this.$message({
          message: 'Error loading NPS data. Please try again.',
          type: 'error'
        });
        this.npsData = null;
        this.loadingNPS = false;
        this.showNPSModal = false;
      }
    },
    getScoreCount(score) {
      // Return the count for a specific score from the NPS data
      if (!this.npsData || !this.npsData.allScores) return 0;
      const scoreData = this.npsData.allScores.find(s => s.score === score);
      return scoreData ? scoreData.count : 0;
    },
    
    getScoreHeight(score) {
      // Calculate the height of each bar for the histogram
      if (!this.npsData || !this.npsData.allScores) return '0%';
      
      const scoreData = this.npsData.allScores.find(s => s.score === score);
      if (!scoreData || scoreData.count === 0) return '0%';
      
      const totalResponses = this.npsData.promotors + this.npsData.passives + this.npsData.detractors;
      if (totalResponses === 0) return '0%';
      
      // Scale the bars to make them more visible
      // Find the maximum count to scale properly
      const maxCount = Math.max(...this.npsData.allScores.map(s => s.count));
      
      // Calculate percentage based purely on the ratio to max count
      // No minimum height - let CSS handle minimum visible height
      return `${(scoreData.count / maxCount) * 95}%`;
    },
    
    getScoreColor(score) {
      // Determine the color of the bar based on the score
      if (!this.npsData) return '#ccc';
      
      if (score >= 9) {
        return '#76ca7d'; // Promoters - Green
      } else if (score >= 7) {
        return '#eed24e'; // Passives - Yellow
      } else {
        return '#ff4e4e'; // Detractors - Red
      }
    },
    
    getScoreClass(score) {
      if (score === null || score === undefined) return '';
      if (score >= 30) return 'score-good';
      if (score >= 0) return 'score-okay';
      return 'score-poor';
    },
    
    benchmarkScore(type) {
      // Return the benchmark score based on type
      if (!type) {
        // Default to NPS if type is undefined
        return 50;
      }
      
      if (type === 'enps') {
        return 30;
      } else if (type === 'nps') {
        return 50;
      } else {
        return 10; // Default benchmark for other types
      }
    },
    getScoreRange() {
      // Return an array of scores from 0 to 10 for NPS/eNPS
      return Array.from({ length: 11 }, (_, i) => i);
    },
    // Helper method to check if a quarter has data
    async checkQuarterHasData(db, questId, quarter) {
      const snapshot = await db.collection('insight_teams_report_card')
        .where('company', '==', this.user.company)
        .where('quest_id', '==', questId)
        .where('quarter', '==', quarter)
        .limit(1)
        .get();
      
      return !snapshot.empty;
    },
  },
};
</script>
<style lang="scss" scoped>
img {
  border-radius: 50%;
}

.flex.card {
  justify-content: center;
}

.txtOption2 {
  color: #4a4a4a;
  font-size: 16px;
  margin-left: 16px;
  width: 160px;
  display: inline-block;
}

.divTable {
  flex: 1;
  width: 898px;
  margin-top: 6px;
  margin-bottom: 10px;
}

.report-loading-shell {
  min-height: 460px;
  display: flex;
  align-items: flex-start;
  padding-top: 20px;
}

.report-loading-table {
  width: 100%;
}

.report-skeleton-headline-row {
  display: flex;
  align-items: flex-end;
  gap: 24px;
  padding-bottom: 28px;
}

.report-skeleton-quarter {
  width: 220px;
  height: 16px;
  border-radius: 999px;
}

.report-skeleton-chip-row {
  display: grid;
  flex: 1;
  gap: 18px;
}

.report-skeleton-chip {
  width: 88px;
  height: 12px;
  border-radius: 999px;
  justify-self: center;
  opacity: 0.65;
  transform: rotate(-34deg);
  transform-origin: center bottom;
}

.report-skeleton-header-row,
.report-skeleton-row {
  display: grid;
  grid-template-columns: 350px minmax(0, 1fr);
  align-items: center;
  gap: 18px;
  padding: 16px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.report-skeleton-header-row {
  padding-top: 18px;
  padding-bottom: 18px;
}

.report-skeleton-axis {
  width: 184px;
  height: 14px;
  border-radius: 999px;
}

.report-skeleton-header-values {
  display: grid;
  gap: 12px;
}

.report-skeleton-header-cell {
  width: 72px;
  height: 12px;
  border-radius: 999px;
  justify-self: center;
  opacity: 0.55;
}

.report-skeleton-row:first-of-type {
  border-top-color: rgba(0, 0, 0, 0.04);
}

.report-skeleton-label {
  height: 14px;
  border-radius: 999px;
  flex-shrink: 0;
}

.report-skeleton-values {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  flex: 1;
}

.report-skeleton-cell {
  width: 64px;
  height: 16px;
  border-radius: 999px;
  justify-self: center;
}

.report-skeleton-cell-soft {
  opacity: 0.55;
}

.report-loader-fade-enter-active,
.report-loader-fade-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}

.report-loader-fade-enter,
.report-loader-fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

@media (max-width: 960px) {
  .report-loading-shell {
    min-height: 400px;
    padding-top: 18px;
  }

  .report-skeleton-headline-row,
  .report-skeleton-header-row,
  .report-skeleton-row {
    grid-template-columns: 1fr;
  }

  .report-skeleton-headline-row {
    gap: 14px;
    padding-bottom: 20px;
  }

  .report-skeleton-chip-row {
    justify-items: start;
    gap: 12px;
  }

  .report-skeleton-chip {
    transform: none;
    justify-self: start;
  }

  .report-skeleton-values {
    gap: 8px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .report-loader-fade-enter-active,
  .report-loader-fade-leave-active {
    transition: none;
  }
}

.txtHeader {
  font-size: 18px;
  font-weight: 700;
}

.menuOptionStyle {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
}

.txtStyle {
  color: #747474;
  font-size: 15px;
  font-weight: 700;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  color: #000000;
  font-size: 18px;
}

.txtHeaderModal {
  font-size: 20px;
  color: #000000;
  font-weight: 800;
}

.iconExport {
  cursor: pointer;
  top: -3px;
  left: 10px;
  position: relative;
}

.el-dropdown-menu {
  overflow-y: auto;
  max-height: 300px;
}

.hover-tooltip {
  width: 65px;
  height: 24px;

  img {
    margin-left: auto;
    margin-right: 4px;
  }
}

.hover-score {
  width: 30px;
  width: 30px;
  justify-content: center;
  display: flex;
}

.mouseover-title {
  .icons-chart {
    cursor: pointer;
  }
  &:hover {
    .icons-chart {
      border: 2px solid #6c30cc;
      background-color: #6c30cc;

      .line {
        background-color: #fff;
      }
    }
  }

  .icons-chart {
    border-radius: 2px;
    border: 2px solid #00000050;
    padding: 2px;
    width: 16px;
    height: 16px;
    transition: 0.2s;

    .line {
      transition: 0.2s;
      width: 2px;
      background-color: #00000050;
    }

    .line-1 {
      height: 5px;
      margin-top: 2px;
      margin-right: 1px;
    }

    .line-2 {
      height: 7px;
      margin-right: 1px;
    }

    .line-3 {
      height: 3px;
      margin-top: 4px;
    }
  }
}

.switch {
  .input {
    position: absolute;
    opacity: 0;
  }

  label {
    cursor: pointer;

    .switch-body {
      transition: 0.3s;
      width: 198px;
      height: 38px;
      background-color: #fff;
      border: 1px solid #c7c7c7;
      border-radius: 4px;
      position: relative;

      &::before {
        position: absolute;
        transition: 0.3s;
        content: "";
        left: -2%;
        background-color: #6c30cc;
        border-radius: 6px;
        width: 100px;
        height: 40px;
      }

      .label-select {
        transition: 0.4;
        z-index: 9;
        font-size: 12px;
        user-select: none;
      }

      .label-select.left {
        color: #fff;
        font-weight: 900;
        margin-left: 26px;
      }

      .label-select.right {
        margin-left: 26px;
        font-weight: 700;
        color: rgba($color: #000000, $alpha: 0.4);
      }
    }
  }

  label.power-on .switch-body {

    // background-color: #32c2d5;
    // color: #fff;
    // border: 1px solid #32c2d5;
    &::before {
      left: 100px;
      // border: 1px solid #32c2d5;
    }

    .label-select.left {
      color: rgba($color: #000000, $alpha: 0.4);
      font-weight: 700;
      margin-left: 30px;
    }

    .label-select.right {
      font-weight: 900;
      color: #fff;
    }
  }
}

.mock-switch {
  background-color: #6c30cc;
  border-radius: 6px;
  width: 100px;
  height: 40px;
  color: #fff;
  font-weight: 900;
  font-size: 12px;
}

.alignment-flag {
  display: inline-flex;
  vertical-align: middle;
}

.strategic-alignment-link {
  transition: all 0.2s ease;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #6C30CC;
  }

  .span-tag {
    text-decoration: none;
  }
}
</style>
<style lang="scss">
.content-container-insightsReport {
  padding: 6px 14px;
  width: 480px;
  transition: 0.2s;
}

#insightsReport div.showOption>ul>li>div {
  height: 40px !important;
  line-height: 40px !important;
}

#insightsReport div.showOption>ul>li>div {
  height: 40px !important;
  line-height: 40px !important;
}

#insightsReport .el-dialog {
  width: 530px;
  padding: 12px;
}

#insightsReport .el-dialog__body {
  padding: 15px 20px 0px 20px;
}

#insightsReport .el-form-item__content {
  color: #4a4a4a;
  font-size: 16px;
  font-weight: 700;
}

#insightsReport .input-style .el-input__inner {
  border-color: #c7c7c7;
}

#reportTable.el-table td {
  border-bottom: 0px solid #e6e5e4 !important;
  border-left: 1px solid #e6e5e4 !important;
  border-right: 0px solid #e6e5e4 !important;
  border-top: 1px solid #e6e5e4 !important;
}

.el-table--border th.fixedTable {
  border-bottom: 1px solid #e6e5e4;
  border-left: none;
  border-right: none;
}

.el-table th.fixedTable {
  position: inherit;
  overflow: visible;
  padding: 0;

  >.fixedTable {
    padding-top: 40px;
    width: 100%;
    position: relative;
  }
}

.el-table th.fixedTable div,
.el-table th .labelTable div {
  overflow: visible;
}

.LabelHeaderStyle {
  font-weight: 700;
  word-break: nowrap;
}

#reportTable>div>div>table>thead>tr>th>div {
  display: flex;
  align-items: center;
  word-break: normal;
}

#reportTable .el-table__body td {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

th .horizontalText>div {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  width: 100% !important;
}

th .rotate-7 {
  -webkit-transform:
    /* Magic Numbers */
    rotate(315deg);
  transform:
    /* Magic Numbers */
    rotate(315deg);
  width: 60px;
}

th .rotate-6 {
  transform:
    /* Magic Numbers */
    translate(10px, -10px) rotate(315deg);
  width: 80px;
}

th .rotate-5 {
  transform:
    /* Magic Numbers */
    translate(20%, -70%) rotate(315deg);
  width: 102px;
}

th .rotate-4 {
  transform: translate(10%, -100%) rotate(315deg);
  width: 130px;
}

th .rotate-3 {
  -webkit-transform: translate(10%, -200%) rotate(315deg);
  transform: translate(10%, -200%) rotate(315deg);
  width: 160px;
}

.el-table th.gutter,
.el-table td.gutter {
  display: block;
}

.tooltipStyle {
  width: 280px;
}

.style-link {
  font-size: 12px;
  font-style: italic;
  color: #ffffff;
  text-decoration: underline;
}

.strategic-alignment-modal {
  .el-dialog__header {
    padding: 0;
    margin: 0;

    .el-dialog__title {
      display: none;
    }

    .el-dialog__headerbtn {
      top: 16px;
      right: 16px;
      z-index: 10;
    }
  }

  .modal-content {
    background: #FFFFFF;
    border-radius: 8px;
    min-height: 200px;
    position: relative;
  }

  .header {
    display: flex;
    align-items: center;
    padding: 16px 20px 32px 20px;
    border-bottom: 1px solid #EEEEEE;
    // background: #F8F8F8;

    svg {
      color: #6C30CC;
    }

    span {
      font-weight: 700;
      font-size: 20px;
      color: #2B2B2B;
      
      .team-name {
        font-weight: 600;
        color: #6C30CC;
      }
      
      .time-period {
        font-weight: 400;
        font-size: 14px;
        color: #666;
        margin-left: 4px;
      }
    }
  }

  .global-legend {
    padding: 12px 20px;
    border-bottom: 1px solid #EEEEEE;
    // background: #FAFAFA;
  }

  .legend-items {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 16px;
  }

  .legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #4A4A4A;

    .legend-color {
      width: 12px;
      height: 12px;
      border-radius: 3px;

      &.strongly-agree {
        background-color: #00b383;
      }

      &.agree {
        background-color: #76ca7d;
      }

      &.neutral {
        background-color: #eed24e;
      }

      &.disagree {
        background-color: #ff4e4e;
      }

      &.strongly-disagree {
        background-color: #d33e3e;
      }

      &.scale-promoter {
        background-color: #00b383;
      }

      &.scale-high {
        background-color: #76ca7d;
      }

      &.scale-moderate {
        background-color: #eed24e;
      }

      &.scale-low {
        background-color: #ff4e4e;
      }

      &.scale-zero {
        background-color: #d33e3e;
      }
    }
  }

  .body {
    padding: 32px 20px 20px 20px;
  }
  
  .segment-note {
    margin-bottom: 16px;
    padding: 8px 12px;
    background-color: #f0f7ff;
    border-left: 3px solid #6C30CC;
    border-radius: 4px;
    font-size: 14px;
    color: #555;
  }
  
  .no-team-selected {
    margin: 30px 0;
    
    .message {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      background-color: #f9f9f9;
      border-radius: 8px;
      border: 1px dashed #ccc;
      
      .info-icon {
        color: #6C30CC;
        margin-right: 12px;
      }
      
      p {
        margin: 0;
        font-size: 16px;
        color: #555;
      }
    }
  }

  .segment-item {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .segment-header {
    font-size: 16px;
    font-weight: 700;
    color: #000000;
    margin-bottom: 12px;
    padding-bottom: 6px;
    // border-bottom: 1px solid #EEEEEE;
  }

  .questions-container {
    background: #FAFAFA;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    overflow: hidden;
  }

  .question-item {
    padding: 16px;
    background: transparent;

    &:first-child {
      padding-bottom: 8px;
    }

    &:not(:first-child) {
      padding-top: 8px;
    }

    &.question-item-divider {
      border-bottom: 1px solid #EEEEEE;
      padding-bottom: 16px;
      margin-bottom: 0;
    }

    .question-header {
      margin-bottom: 10px;

      .question-text-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        gap: 16px;
      }

      .question-text {
        font-size: 16px;
        font-weight: 600;
        line-height: 1.4;
        color: #2B2B2B;
        flex: 1;
      }

      .score-container {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }

      .question-score {
        font-size: 16px;
        font-weight: 600;
        color: #2B2B2B;
        white-space: nowrap;

        &::after {
          content: '%';
          font-size: 14px;
          opacity: 0.7;
          margin-left: 1px;
        }
      }

      .response-count {
        font-size: 12px;
        color: #666666;
        margin-top: 4px;
      }
    }
  }

  .response-breakdown {
    .bar-container {
      height: 28px;
      display: flex;
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      width: 100%;
    }

    .bar-segment {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
      font-size: 12px;
      font-weight: 600;
      transition: all 0.3s ease;
      min-width: 0;

      .bar-label {
        white-space: nowrap;
        text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
        padding: 0 4px;

        &::after {
          content: '%';
          font-size: 10px;
          opacity: 0.9;
          margin-left: 1px;
        }
      }

      .bar-label-hidden {
        width: 100%;
        height: 100%;
      }

      &.bar-results-strongly-agree { background-color: #00b383; }
      &.bar-results-agree { background-color: #76ca7d; }
      &.bar-results-neutral { 
        background-color: #eed24e;
        color: #2B2B2B;
      }
      &.bar-results-disagree { background-color: #ff4e4e; }
      &.bar-results-strongly-disagree { background-color: #d33e3e; }

      &.bar-scale-promoter { background-color: #00b383; }
      &.bar-scale-high { background-color: #76ca7d; }
      &.bar-scale-moderate {
        background-color: #eed24e;
        color: #2B2B2B;
      }
      &.bar-scale-low { background-color: #ff4e4e; }
      &.bar-scale-zero { background-color: #d33e3e; }
    }
  }

  .no-data-message {
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    border-radius: 4px;
    border: 1px dashed #d0d0d0;
    
    .no-data-text {
      font-size: 12px;
      color: #666666;
      font-style: italic;
    }
  }
}

.who-5-modal {
  @extend .strategic-alignment-modal;
  
  .global-legend {
    .legend-items {
      .legend-item {
        .legend-color {
          &.all-time {
            background-color: #068462; // Dark green (swapped)
          }
          &.most-time {
            background-color: #00b383; // Bright green (swapped)
          }
          &.more-half {
            background-color: #76ca7d; // Light green
          }
          &.less-half {
            background-color: #eed24e; // Yellow
          }
          &.some-time {
            background-color: #ff4e4e; // Light red
          }
          &.no-time {
            background-color: #d33e3e; // Dark red
          }
        }
      }
    }
  }

  .response-breakdown {
    .bar-segment {
      &.bar-who5-all-time { 
        background-color: #068462; // Dark green (swapped)
      }
      &.bar-who5-most-time { 
        background-color: #00b383; // Bright green (swapped)
      }
      &.bar-who5-more-half { 
        background-color: #76ca7d; // Light green
      }
      &.bar-who5-less-half { 
        background-color: #eed24e; // Yellow
        color: #2B2B2B; // Dark text for better contrast on yellow
      }
      &.bar-who5-some-time { 
        background-color: #ff4e4e; // Light red
      }
      &.bar-who5-no-time { 
        background-color: #d33e3e; // Dark red
      }
    }
  }
}

.nps-modal {
  @extend .strategic-alignment-modal;
  
  .modal-content {
    background: #FFFFFF;
    border-radius: 8px;
    min-height: 200px;
    position: relative;
  }

  .header {
    padding: 24px;
    border-bottom: 1px solid #EEEEEE;
    
    .team-name {
      font-weight: 600;
      color: #6C30CC;
    }
    
    .time-period {
      font-weight: 400;
      font-size: 14px;
      color: #666;
      margin-left: 4px;
    }
  }

  .period-subtitle {
    padding: 8px 24px 0;
    font-size: 14px;
    color: #666;
    text-align: center;
    font-style: italic;
  }

  .global-legend {
    padding: 16px 24px;
    border-bottom: 1px solid #EEEEEE;
    
    .legend-items {
      display: flex;
      justify-content: center;
      gap: 24px;
    }

    .legend-item {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 13px;
      color: #4A4A4A;

      .legend-color {
        width: 12px;
        height: 12px;
        border-radius: 3px;

        &.promoter {
          background-color: #35d077;
        }
        &.passive {
          background-color: #fbc02d;
        }
        &.detractor {
          background-color: #f44336;
        }
      }
    }
  }

  .body {
    padding: 24px;

    .score-summary {
      display: flex;
      gap: 32px;
      margin-bottom: 32px;
      
      .score-box {
        text-align: center;
        padding: 24px;
        background: #F8F8F8;
        border-radius: 8px;
        min-width: 120px;
        
        .score-value {
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 8px;
          
          &.score-good { color: #35d077; }
          &.score-okay { color: #fbc02d; }
          &.score-poor { color: #f44336; }
        }
        
        .score-label {
          font-size: 14px;
          color: #666;
        }
      }
      
      .distribution-boxes {
        display: flex;
        gap: 16px;
        flex: 1;
        
        .dist-box {
          flex: 1;
          padding: 16px;
          border-radius: 8px;
          text-align: center;
          
          &.promoters {
            background: rgba(53, 208, 119, 0.1);
            .dist-value { color: #35d077; }
          }
          &.passives {
            background: rgba(251, 192, 45, 0.1);
            .dist-value { color: #fbc02d; }
          }
          &.detractors {
            background: rgba(244, 67, 54, 0.1);
            .dist-value { color: #f44336; }
          }
          
          .dist-value {
            font-size: 24px;
            font-weight: 700;
            margin-bottom: 4px;
          }
          
          .dist-count {
            font-size: 12px;
            color: #666;
            margin-bottom: 8px;
          }
          
          .dist-label {
            font-size: 14px;
            font-weight: 600;
            color: #4A4A4A;
          }
        }
      }
    }

    .score-distribution {
      margin-bottom: 32px;
      
      .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #2B2B2B;
        margin-bottom: 16px;
      }

      .horizontal-histogram {
        height: 350px;
        margin-top: 20px;
        
        .histogram-container {
          display: flex;
          flex-direction: column;
          height: 100%;
          
          .score-bars {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            height: 300px;
            width: 100%;
            padding-top: 30px; /* Add space for external labels */
            
            .score-column {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-end;
              width: 8%;
              height: 100%;
              position: relative;
              
              .histogram-bar {
                width: 100%;
                border-radius: 4px 4px 0 0;
                display: flex;
                align-items: flex-start;
                justify-content: center;
                font-size: 13px;
                color: #fff;
                font-weight: 500;
                text-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
                min-height: 2px; /* Set a very small minimum height so bar is always visible */
                transition: height 0.3s ease;
                text-align: center;
                
                /* Hide text inside small bars */
                & > span {
                  display: none;
                  padding-top: 8px;
                }
              }
              
              /* For bars taller than 30px, show text inside */
              .histogram-bar[style*="height: 30%"] > span,
              .histogram-bar[style*="height: 40%"] > span,
              .histogram-bar[style*="height: 50%"] > span,
              .histogram-bar[style*="height: 60%"] > span,
              .histogram-bar[style*="height: 70%"] > span,
              .histogram-bar[style*="height: 80%"] > span,
              .histogram-bar[style*="height: 90%"] > span {
                display: block;
              }
              
              .external-count {
                position: absolute;
                top: -25px;
                left: 0;
                width: 100%;
                text-align: center;
                color: #666;
                font-size: 12px;
                font-weight: 500;
              }
              
              .score-label {
                margin-top: 8px;
                font-size: 12px;
                color: #666;
                text-align: center;
              }
            }
          }
        }
      }
    }

    .benchmark-section {
      .benchmark-box {
        padding: 16px;
        border-radius: 8px;
        text-align: center;
        
        &.positive {
          background: rgba(53, 208, 119, 0.1);
          .benchmark-value { color: #35d077; }
        }
        
        &.negative {
          background: rgba(244, 67, 54, 0.1);
          .benchmark-value { color: #f44336; }
        }
        
        .benchmark-value {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 4px;
        }
        
        .benchmark-label {
          font-size: 13px;
          color: #666;
        }
      }
    }
  }
}

// ... rest of existing styles ...
</style>
